import { ServiceCodeTypeAndAffiliationType } from '@/@types/billing/utility/index'

interface DefineType {
  ACHIEVEMENTS_FLG_ARRAY: string[]
  ADDITION_ARRAY: string[]
  ATTENDANCE_ARRAY: string[]
  TEMPORARY_ATTENDANCE_MODAL_ARRAY: { [key: string]: string | number }[]
  ATTENDANCE_MODAL_ARRAY: { [key: string]: string | number }[]
  TEMPORARY_MODAL_ATTENDANCE_ARRAY: { [key: string]: string | number }[]
  ACHIEVEMENTS_MODAL_ARRAY: { [key: string]: string | number }[]
  ACHIEVEMENTS_MODAL_ATTENDANCE_MSG_ARRAY: { [key: string]: string | number }[]
  ACHIEVEMENTS_VISIT_MODAL_ATTENDANCE_MSG_ARRAY: {
    [key: string]: string | number
  }[]
  ACHIEVEMENTS_DELETE_MODAL_ARRAY: { [key: string]: string | number }[]
  ACTIVE_ARRAY: { [key: string]: string | number }[]
  ACTIVE_SODAN_ARRAY: { [key: string]: string | number }[]
  ACTIVE_TEMPORARY_ARRAY: string[]
  ALLOW_SEAT_ID_ARRAY: string[]
  ALLOW_GROUP_ARRAY: { [key: string]: string | boolean }[]
  CAR_COMPATIBILITY_ARRAY: string[]
  CONTACT_METHOD_ARRAY: string[]
  CONTACT_ARRAY: string[]
  DAY_ARRAY: string[]
  DOCUMENT_OPTION_ARRAY: string[]
  EARLY_LEAVE_ARRAY: string[]
  EXCRETION_ARRAY: string[]
  EMPLOYEE_ARRAY: string[]
  ENTRANCE_DOCUMENTS_ARRAY: string[]
  FORMULA_WEEK_ARRAY: string[]
  FRONT_POSITION_ARRAY: string[]
  HOUR_ARRAY: number[]
  STR_HOUR_ARRAY: string[]
  STR_MONTH_ARRAY: string[]
  HANDICAPPE_OPTION_ARRAY: string[]
  LATE_ARRAY: string[]
  LINE_ACTIVE_ARRAY: string[]
  LINE_BLOCK_ARRAY: string[]
  MIN_ARRAY: number[]
  STR_MIN_ARRAY: string[]
  MIN_OPTION_ARRAY: string[]
  MONTH_ARRAY: number[]
  MONTH_STR_ARRAY: string[]
  NOT_SELECT_ATTENDANCE: number
  POSSIBLE_ARRAY: { [key: string]: string | boolean }[]
  PICKUP_ACHIEVEMENTS_ARRAY: string[]
  PICKUP_ARRAY: string[]
  PICKUP_TEXT_ARRAY: string[]
  PROVISION_ARRAY: string[]
  REAR_POSITION_ARRAY: string[]
  RADIO_TACKING_ARRAY: string[]
  RADIO_SEND_ARRAY: string[]
  SEND_FLG_ARRAY: string[]
  SIGN_FLG_ARRAY: string[]
  STAFF_ACTIVE_ARRAY: string[]
  SEND_OPTION_ARRAY: string[]
  SUPPORT_ARRAY: string[]
  SNACK_ARRAY: string[]
  SCHOOL_OPTION_ARRAY: string[]
  AGE_AND_SCHOOL_OPTION_ARRAY: { [key: string]: string }[]
  TACKING_FLG_ARRAY: string[]
  TEMPORARY_ATTENDANCE_ARRAY: string[]
  TACK_OPTION_ARRAY: string[]
  WEEK_OPTION_ARRAY: string[]
  YEAR_ARRAY: string[]
  PREFECTURE_OPTION_ARRAY: { [key: string]: string | number }[]
  ROOT_ACTIVE_ARRAY: string[]
  ROOT_ARRAY: string[]
  SCHOOL_OPENING_SATURDAY_ARRAY: string[]
  SCHOOL_YEAR_ARRAY: string[]
  SCHOOL_TYPE_ARRAY: string[]
  SCHOOL_WEEK_ARRAY: string[]
  UPPER_LIMIT_ARRAY: string[]
  IS_DISPLAY_ARRAY: string[]
  ACHIVEMENTS_STS_ARRAY: string[]
  BENEFIT_STS_ARRAY: string[]
  INVOICE_STS_ARRAY: string[]
  PRE_SCHOOL_FLG_ARRAY: {
    value: string
    areaClassLevel: string[]
    text: string
  }[]
  // 基礎調査資料１   start
  APPLICATIONNOTEBOOK_OPTION_ARRAY: string[]
  GENDER_OPTION_ARRAY: string[]
  PRESENTSITUATION_OPTION_ARRAY: string[]
  KINDOFNOTEBOOK_OPTION_ARRAY: string[]
  PREFECTURALANDCITY_OPTION_ARRAY: { [key: string]: string | number }[]
  MENTALHEALTHNOTEBOOK_OPTION_ARRAY: string[]
  MENTALHEALTHNOTEBOOK_SELECT_OPTION_ARRAY: string[]
  PREFECTUALANDCITY_OPTION_ARRAY: string[]
  DISABILITYINFORMATION_OPTION_ARRAY: string[]
  LONGTERMCARE_OPTION_ARRAY: string[]
  HEALTHINSURANCE_OPTION_ARRAY: string[]
  NATIONALINSURANCE_OPTION_ARRAY: string[]
  SOCIALINSURANCE_OPTION_ARRAY: string[]
  MAININCOME_OPTION_ARRAY: string[]
  HOUSEHOLDFORM_OPTION_ARRAY: string[]
  LIVEWITHCHILD_OPTION_ARRAY: string[]
  LIVEWITHRELATIVES_OPTION_ARRAY: string[]
  JAPANESECALENDAR_OPTION_ARRAY: string[]
  RELATIONSHIP_OPTION_ARRAY: string[]
  WHETHERTOLIVETOGETHER_OPTION_ARRAY: string[]
  CAREGIVER_OPTION_ARRAY: string[]
  SURVIVAL_OPTION_ARRAY: string[]
  // 基礎調査資料１   stop

  // 基礎調査資料２   start
  INTERVIEWSOPPONENT_OPTION_ARRAY: string[]
  DELIVERYELAPSED_OPTION_ARRAY: string[]
  FETALPOSITION_OPTION_ARRAY: string[]
  APPARENTDEATH_OPTION_ARRAY: string[]
  JAUNDICE_OPTION_ARRAY: string[]
  SUCKLING_OPTION_ARRAY: string[]
  EPILEPSY_OPTION_ARRAY: string[]
  PLAYMATE_OPTION_ARRAY: string[]
  REMOVABLE_OPTION_ARRAY: string[]
  YES_AND_NO_OPTION_ARRAY: string[]
  // 基礎調査資料２   stop

  // 基礎調査資料３   start
  ROLLINGOVER_OPTION_ARRAY: string[]
  GETUP_OPTION_ARRAY: string[]
  SITTINGPOSITIONHELD_OPTION_ARRAY: string[]
  STANDINGHOLDING_OPTION_ARRAY: string[]
  TRANSFER_OPTION_ARRAY: string[]
  ELECTRICBED_OPTION_ARRAY: string[]
  USEOFAIRMAT_OPTION_ARRAY: string[]
  INDOOR_OPTION_ARRAY: string[]
  OUTDOORS_OPTION_ARRAY: string[]
  TUBANDOUT_OPTION_ARRAY: string[]
  WASHING_OPTION_ARRAY: string[]
  SHAMPOO_OPTION_ARRAY: string[]
  METHOD_OPTION_ARRAY: string[]
  URINATION_OPTION_ARRAY: string[]
  URINATE_OPTION_ARRAY: string[]
  TRANSMISSION_OPTION_ARRAY: string[]
  DEFECATION_OPTION_ARRAY: string[]
  BOWELMOVEMENT_OPTION_ARRAY: string[]
  INCOUNTINENCE_OPTION_ARRAY: string[]
  BOWELMOVE_OPTION_ARRAY: string[]
  INDIRECTSUPPORT_OPTION_ARRAY: string[]
  EXCRETIONMETHOD_OPTION_ARRAY: string[]
  DIETARYINTAKE_OPTION_ARRAY: string[]
  DRINKINGWATER_OPTION_ARRAY: string[]
  SWALLOWING_OPTION_ARRAY: string[]
  MEALFORM_OPTION_ARRAY: string[]
  USEOFSELFHELPTOOL_OPTION_ARRAY: string[]
  USEORGANICSELFHELPTOOL_OPTION_ARRAY: string[]
  DIET_OPTION_ARRAY: string[]
  CLEANLINESS_OPTION_ARRAY: string[]
  IADL_OPTION_ARRAY: string[]
  EYESIGHT_OPTION_ARRAY: string[]
  PRESENCEORABSENCE_OPTION_ARRAY: string[] //有無
  LEFTORRIGHT_OPTION_ARRAY: string[] //左右
  PROPRIETY_OPTION_ARRAY: string[] //可否
  TRANSMISSIONOFINTENTION_OPTION_ARRAY: string[]
  LEVELOFUNDERSTANDING_OPTION_ARRAY: string[]
  SPEAK_OPTION_ARRAY: string[]
  WRITE_OPTION_ARRAY: string[]
  READ_OPTION_ARRAY: string[]
  DISABILITY_RIGHT_AND_LEFT: string[]
  HEARING_OPTION_ARRAY: string[]
  // 基礎調査資料３   stop

  // 基礎調査資料４   start
  AFFAIRSPROCESSING_OPTION_ARRAY: string[]
  MANIFESTATIONOFINTENTION_OPTION_ARRAY: string[]
  UNDERSTANDINGOFCOMMUNICATION_OPTION_ARRAY: string[]
  EVERYDAYLIFE_OPTION_ARRAY: string[]
  OUTDOORMOVEMENT_OPTION_ARRAY: string[]
  INTERPERSONALRELATIONSANDMONEYMANAGEMENT_OPTION_ARRAY: string[]
  LETTER_OPTION_ARRAY: string[]
  GROUP_OPTION_ARRAY: string[]
  TIME_OPTION_ARRAY: string[]
  SYMBOLSELECTION_OPTION_ARRAY: string[]
  // 基礎調査資料４   stop

  // 基礎調査資料５   start
  NUMBERSELECTION_OPTION_ARRAY: string[]
  ALPHABETSELECTION_OPTION_ARRAY: string[]
  // 基礎調査資料５   stop

  // 基礎調査資料６   start
  ORAL_OPTION_ARRAY: string[]
  HAVEINFECTION_OPTION_ARRAY: string[]
  HAVEARTIFICIALTOOTH_OPTION_ARRAY: string[]
  SLEEP_OPTION_ARRAY: string[]
  DRINKING_OPTION_ARRAY: string[]
  SMOKING_OPTION_ARRAY: string[]
  MALADAPTIVETOTHEPOPULATION_OPTION_ARRAY: string[]
  SOCIALACTIVITIESTIME_OPTION_ARRAY: string[]
  SOCIALACTIVITIESMINUTE_OPTION_ARRAY: string[]
  // 基礎調査資料６   stop

  UPPER_LIMIT_CREATION_CATEGORY: { [key: string]: string }[]
  UBUPPER_LIMIT_MONTHLY_AMOUNT_ARRAY: string[]
  BILLING_AREA_CLASS_ARRAY: { [key: string]: string }[]
  AREA_CLASS_LEVEL_ARRAY: { [key: string]: string }[]
  KASAN_CLASSIFICATION_ARRAY: { [key: string]: string }[]
  KASAN_PLACEMENT_ARRAY: { [key: string]: string }[]
  KASAN_JIDOSHIDOIN_ARRAY: { [key: string]: string }[]
  KASAN_WELFARE_ARRAY: { [key: string]: string }[]
  KASAN_SPECIFIC_TREATMENT_ARRAY: { [key: string]: string }[]
  KASAN_REVISION_TREATMENT_ARRAY: { [key: string]: string }[]
  KASAN_REVISION_VISIT_TREATMENT_ARRAY: { [key: string]: string }[]
  KASAN_TREATMENT_ARRAY: { [key: string]: string }[]
  SEVERE_CHILD_ARRAY: { [key: string]: string }[]
  SPECIAL_PLAN_ARRAY: { [key: string]: string }[]
  MANY_CHILDREN_NO_ARRAY: { [key: string]: string }[]
  FREE_CHARGE_ARRAY: { [key: string]: string }[]
  MEDICAL_CARE_CHILD_ARRAY: { [key: string]: string }[]
  MEDICAL_CARE_CHILD_TOOLTIP_OBJ: {
    tooltipTitle: string
    tooltipTextLink: string
    tooltipTextArray: { [key: string]: string }[]
  }

  // 事業形態
  AFFILIATION_ARRAY: { value: string; text: string }[]
  AFFILIATION_TUSYO_ARRAY: { value: string; text: string }[]
  AFFILIATION_HOMON_ARRAY: { value: string; text: string }[]
  AFFILIATION_SODAN_ARRAY: { value: string; text: string }[]
  AFFILIATION_CENTER_OBJ: { value: string; text: string }
  AFFILIATION_GOVERNMENT_OBJ: { value: string; text: string }
  AFFILIATION_SODAN_OBJ: { value: string; text: string }

  // 児童の所属アイコン
  AFFILIATION_ICON_ARRAY: { [key: string]: string }[]
  // 児童の所属アイコン+相談
  AFFILIATION_TYPE_ICON_ARRAY: { [key: string]: string }[]

  // フィルター用の所属オブジェクト
  AFFILIATION_FILTER_ARRAY: { [key: string]: string }[]
  // フィルター用の状態オブジェクト
  ACTIVE_FILTER_ARRAY: { [key: string]: string | number }[]

  JIHATSU_KASAN_SPECIALTY_ARRAY: { [key: string]: string }[]
  ATTENDANCE_TYPE_ARRAY: string[]
  AT_FLG_VALUE_OBJ_ARRAY: { atFlg: number }[]
  COME_TYPE_ARRAY: { [key: string]: string }[]
  RETURN_TYPE_ARRAY: { [key: string]: string }[]

  PROVISION_FORM_ARRAY: { [key: string]: string | number }[]
  ALTERNATIVE_SUPPORT_ARRAY: { [key: string]: string }[]
  AVAILABLE_ARRAY: { [key: string]: string | number }[]
  STR_AVAILABLE_ARRAY: { [key: string]: string }[]
  ACHIVEMENTS_KASAN_KEY_ARRAY: string[]
  ACHIVEMENTS_REVISION_2024_KASAN_KEY_ARRAY: string[]
  ACHIVEMENTS_REVISION_2024_KASAN_TIME_KEY_ARRAY: string[]
  ACHIVEMENTS_KASAN_KEY_TEXT_ARRAY: { [key: string]: string }[]
  ACHIVEMENTS_REVISION_2024_KASAN_KEY_TEXT_ARRAY: { [key: string]: string }[]
  HOME_ADDITION_KEY_ARRAY: string[]
  CONSULTATION_ADDITION_KEY_ARRAY: string[]

  STAFF_ROLE_ARRAY: { [key: string]: string | number }[]
  STAFF_AFFILIATION_ARRAY: { [key: string]: string }[]

  STAFF_ATTENDANCE_ARRAY: { [key: string]: string }[]

  UB_CLD_UPPER_LIMIT_NUMBER: number[]

  UB_SET_KEY_ARRAY: string[]

  HOLIDAY_TYPE: string[]

  HOLIDAY_OMIT_TYPE: string[]

  ACHIEVEMENTS_FILTER_OPTION_ATTENDANCE_ARRAY: { [key: string]: string }[]
  ACHIEVEMENTS_FILTER_OPTION_STATUS_ARRAY: { [key: string]: string }[]
  ACHIEVEMENTS_FILTER_OPTION_AFFILIATION_ARRAY: { [key: string]: string }[]
  PRINT_FILTER_OPTION_AFFILIATION_ARRAY: { [key: string]: string }[]
  ATTENDANCE_SELECT_ARRAY: { [key: string]: string | number }[]
  TEMPORARY_SELECT_ARRAY: { [key: string]: string | number }[]
  MULTIPLE_ADDITION_CHECK_ARRAY: { [key: string]: string | number }[]
  MULTIPLE_ADDITION_CHECK_REVISION_2024_ARRAY: {
    [key: string]: string | number
  }[]
  ONE_ADDITION_MULTIPLE_CHECK_ARRAY: { [key: string]: string | number }[]
  ONE_ADDITION_3_MULTIPLE_CHECK_ARRAY: { [key: string]: string | number }[]
  ACHIEVEMENTS_ADDITION_KEY_ARRAY: { [key: string]: string }[]
  ACHIEVEMENTS_REVISION_2024_ADDITION_KEY_ARRAY: { [key: string]: string }[]
  ACHIEVEMENTS_REVISION_2024_ADDITION_VALID_TIME_KEY_ARRAY: {
    [key: string]: string
  }[]
  HOUDAY_AFFILIATION: string
  JIHATSU_AFFILIATION: string
  HOHOU_AFFILIATION: string
  SODAN_AFFILIATION: string
  CHILD_ADDITION_KEY_ARRAY: { [key: string]: string }[]
  CHILD_ADDITION_KEY_ADD_ARRAY: { [key: string]: string }[]
  CHILD_VISIT_ADDITION_KEY_ADD_ARRAY: { [key: string]: string }[]
  CHILD_KASAN_STRENGTH_ARRAY: { [key: string]: string }[]
  CHILD_KASAN_STRENGTH_DATE_ARRAY: { [key: string]: string }[]
  CHILD_ADDITION_DATE_LABEL_ARRAY: string[]
  CHILD_ADDITION_DATE_KEY_ARRAY: { [key: string]: string }[]
  BULK_PRINT_OPTION_ARRAY: { [key: string]: string }[]
  VARIABLE_SERVICE_CODE: string[]
  VARIABLE_NEW_SERVICE_CODE: string[]
  RESET_VALUE_BY_HOHOU: { [key: string]: string }[]
  RESET_VALUE_BY_SODAN: { [key: string]: string }[]
  RESET_VALUE_BY_TUSYO: {
    key: string
    value: string | { [key: string]: string }
  }[]
  CONTRACT_AND_START_USING_DATE: string[]
  DISCRIMINATION_AFFILIATION: { [key: string]: boolean }
  HOHOU_ATTENDANCE_TYPE_ARRAY: string[]
  HOHOU_ATTENDANCE_TYPE_RADIO_ARRAY: { [key: string]: string | number }[]
  ADDITION_NORMAL_FLG: { [key: string]: string }[]
  VISIT_KEY_DEFAULT_ARRAY: {
    key: string
    value: string | []
  }[]
  SERVICE_CODE_TYPE_AND_AFFILIATION_ARRAY: ServiceCodeTypeAndAffiliationType[]
  VISIT_SNAKE_KEY_ARRAY: string[]
  FREE_OF_CHARGE_AND_MANY_CHILD_TARGET_SERVICE_CODE_TYPE_ARRAY: string[]
  OFFICE_CREATION_CATEGORY_TOOLTIP_ARRAY: { tooltipText: string }[]
  APP_INFO: {
    [key: string]: string
  }
  KASAN_EXTENDED_INPUT_ARRAY: {
    label: string
    value: string
  }[]
  KASAN_NEW_EXTENDED_INPUT_ARRAY: {
    label: string
    value: string
  }[]
  KASAN_IKO_SHIEN_INPUT_ARRAY: {
    label: string
    value: string
  }[]
  KASAN_KAZOKU_SHIEN_PLACE_INPUT_ARRAY: {
    label: string
    value: string
  }[]
  KASAN_KAZOKU_SHIEN_PLACE_INPUT_TEXT_ARRAY: {
    text: string
    value: string
  }[]
  KASAN_KAZOKU_SHIEN_2_PLACE_INPUT_TEXT_ARRAY: {
    text: string
    value: string
  }[]
  CALCULATION_TIME_INPUT_ARRAY: {
    label: string
    value: string
  }[]
  CALCULATION_TIME_ARRAY: {
    label: string[]
    value: string
  }[]
  CALCULATION_TIME_OUTPUT_ARRAY: {
    label: string
    value: string
  }[]
  TAX_ARRAY: {
    label: string
    value: number | string
  }[]
  SCHOOL_OPEN_OR_CLOSED_ARRAY: {
    [key: string]: string
  }[]
  LINE_FILTER_ARRAY: {
    [key: string]: string
  }[]
  LINE_STATUS_ARRAY: {
    [key: string]: string
  }[]
  LINE_SEGMENT_DELIVERY_DESTINATION_ARRAY: {
    [key: string]: string
  }[]
  CHILD_KASAN_SUPPORT_1_DETAILS_ARRAY: {
    [key: string]: string
  }[]
  TUTORING_FIVE_AREAS_ARRAY: string[]
  TUTORING_STATUS_ARRAY: string[]
  BANK_TYPE: { [key: string]: string | number }[]
  BASIC_TRANSACTION_DEPOSIT_TYPE: { [key: string]: string | number }[]
  YUCHO_TRANSACTION_DEPOSIT_TYPE: { [key: string]: string | number }[]
  WITHDRAWAL_PERIOD: { [key: string]: string | number }[]
  WITHDRAWAL_DEPOSIT_TYPE: { [key: string]: string | number }[]
  KIJYUN_GAITO_ARRAY: { [key: string]: string }[]
  PICK_POINT_ARRAY: { [key: string]: string }[]
  SEND_POINT_ARRAY: { [key: string]: string }[]
  OFFICE_KYOSEIGATA_SERVICE_ARRAY: { [key: string]: string }[]
  OFFICE_KYOSEIGATA_SERVICE_DETAIL_ARRAY: { [key: string]: string }[]
  ACHIVEMENTS_REVISION_2024_KASAN_DEFAULT_ARRAY: {
    [key: string]: string | number
  }[]
  ACHIVEMENTS_KASAN_DEFAULT_ARRAY: { [key: string]: string | number }[]
  ACHIVEMENTS_DEFAULT_ARRAY: { [key: string]: string | number }[]
  ACHIVEMENTS_REVISION_2024_VISIT_KASAN_DEFAULT_ARRAY: {
    [key: string]: string | number
  }[]
  ACHIVEMENTS_VISIT_KASAN_DEFAULT_ARRAY: { [key: string]: string | number }[]
  APPLICABLE_OPTION_ARRAY: string[]
  PHYSICALDISABILITYNOTEBOOK_SELECT_OPTION_ARRAY: string[]
  TOKUREI_OPTION_ARRAY: string[]
  NAV_BASIC_SURVEY_1_ANCHORS_ARRAY: { text: string; id: string; tab: number }[]
  NAV_BASIC_SURVEY_2_ANCHORS_ARRAY: { text: string; id: string; tab: number }[]
  NAV_BASIC_SURVEY_3_ANCHORS_ARRAY: { text: string; id: string; tab: number }[]
  NAV_BASIC_SURVEY_4_ANCHORS_ARRAY: { text: string; id: string; tab: number }[]
}
export const defineObject: DefineType = {
  NOT_SELECT_ATTENDANCE: 5,
  ACHIEVEMENTS_FLG_ARRAY: ['欠席', ' '],
  ADDITION_ARRAY: [' ', '1', '1'],
  ATTENDANCE_ARRAY: [
    '欠席',
    '出席',
    'お休み',
    '追：承認待ち',
    '欠：承認待ち',
    '休：承認待ち',
    '未選択',
    '',
    '',
    'なし',
  ],
  TEMPORARY_ATTENDANCE_MODAL_ARRAY: [
    {
      value: 0,
      label: '定期',
    },
    {
      value: 1,
      label: '追加',
    },
  ],
  ATTENDANCE_MODAL_ARRAY: [
    {
      value: 0,
      label: '欠席',
    },
    {
      value: 1,
      label: '出席',
    },
    {
      value: 2,
      label: 'お休み',
    },
  ],
  ACHIEVEMENTS_MODAL_ARRAY: [
    {
      value: 0,
      label: '欠席',
    },
    {
      value: 1,
      label: '出席',
    },
    {
      value: 2,
      label: 'お休み',
    },
  ],
  ACHIEVEMENTS_MODAL_ATTENDANCE_MSG_ARRAY: [
    {
      value: 3,
      label: '追加利用の承認待ち',
    },
    {
      value: 4,
      label: '欠席の承認待ち',
    },
    {
      value: 5,
      label: 'お休みの承認待ち',
    },
  ],
  ACHIEVEMENTS_VISIT_MODAL_ATTENDANCE_MSG_ARRAY: [
    {
      value: 2,
      label: '実施キャンセル承認待ち',
    },
  ],
  ACHIEVEMENTS_DELETE_MODAL_ARRAY: [
    {
      value: 99,
      label: 'なし',
    },
    {
      value: 0,
      label: '欠席',
    },
    {
      value: 2,
      label: 'お休み',
    },
  ],
  TEMPORARY_MODAL_ATTENDANCE_ARRAY: [
    {
      value: 0,
      label: '定期利用',
    },
    {
      value: 1,
      label: '追加利用',
    },
  ],
  ACTIVE_ARRAY: [
    {
      label: '仮登録',
      value: 2,
      iconText: '仮',
    },
    {
      label: '在籍中',
      value: 1,
      iconText: '在',
    },
    {
      label: '退所',
      value: 0,
      iconText: '退',
    },
    {
      label: '削除',
      value: 99,
      iconText: '削',
    },
  ],
  ACTIVE_SODAN_ARRAY: [
    {
      label: '在籍中',
      value: 3,
      iconText: '在',
    },
    {
      label: '退所',
      value: 4,
      iconText: '退',
    },
  ],
  ACTIVE_TEMPORARY_ARRAY: ['仮登録'],
  ALLOW_SEAT_ID_ARRAY: ['特になし', '助手席', '添乗員の横', '窓側'],
  ALLOW_GROUP_ARRAY: [
    { label: 'りんご', value: 'ANYONE' },
    { label: 'バナナ', value: 'NOT_ANYONE_01' },
    { label: 'オレンジ', value: 'NOT_ANYONE_02' },
  ],
  CAR_COMPATIBILITY_ARRAY: ['良い', '悪い'],
  CONTACT_METHOD_ARRAY: [
    'メール',
    '電話',
    'ホームページ',
    '連絡帳',
    '直接',
    'その他',
  ],
  CONTACT_ARRAY: [
    '',
    'メール',
    '電話',
    'ホームページ',
    '連絡帳',
    '直接',
    'その他',
  ],
  DAY_ARRAY: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
  ],
  DOCUMENT_OPTION_ARRAY: ['未完了', '完了', '不備有'],
  EARLY_LEAVE_ARRAY: ['通常', '早退'],
  EXCRETION_ARRAY: ['0回', '1回', '2回', '3回', '4回', '5回以上'],
  EMPLOYEE_ARRAY: ['非常勤', '常勤'],
  ENTRANCE_DOCUMENTS_ARRAY: ['未完了', '完了', '不備有'],
  FORMULA_WEEK_ARRAY: ['日', '月', '火', '水', '木', '金', '土'],
  FRONT_POSITION_ARRAY: ['助手席'],
  HOUR_ARRAY: [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
  ],
  STR_HOUR_ARRAY: [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
  ],
  STR_MONTH_ARRAY: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
  ],
  HANDICAPPE_OPTION_ARRAY: ['最重度', '重度', '中度', '軽度'],
  LATE_ARRAY: ['通常', '遅刻'],
  LINE_ACTIVE_ARRAY: ['不使用', '使用中'],
  LINE_BLOCK_ARRAY: ['許可', 'ブロック'],
  MIN_ARRAY: [0, 10, 20, 30, 40, 50],
  STR_MIN_ARRAY: ['00', '10', '20', '30', '40', '50'],
  MIN_OPTION_ARRAY: [
    '00',
    '05',
    '10',
    '15',
    '20',
    '25',
    '30',
    '35',
    '40',
    '45',
    '50',
    '55',
  ],
  MONTH_ARRAY: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  MONTH_STR_ARRAY: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
  ],
  POSSIBLE_ARRAY: [
    { label: 'できない', value: false },
    { label: 'できる', value: true },
  ],
  PICKUP_ACHIEVEMENTS_ARRAY: [' ', '1'],
  PICKUP_ARRAY: ['0', '1', '2'],
  PICKUP_TEXT_ARRAY: ['なし', 'あり'],
  PROVISION_ARRAY: ['1', '2'],
  REAR_POSITION_ARRAY: ['出口側', '窓側'],
  RADIO_TACKING_ARRAY: ['全てを「なし」にする', '全てを「往路」にする'],
  RADIO_SEND_ARRAY: ['全てを「なし」にする', '全てを「復路」にする'],
  SEND_FLG_ARRAY: ['なし', '復路'],
  SIGN_FLG_ARRAY: ['サインなし', 'サインあり'],
  STAFF_ACTIVE_ARRAY: ['退職', '在籍中'],
  SEND_OPTION_ARRAY: ['送り不要', '送り必要'],
  SUPPORT_ARRAY: ['ADL', 'コミュニケーション', '社会性', '認知発達'],
  SNACK_ARRAY: ['1', '2', '3', '4', '5', '持ち帰り'],
  SCHOOL_OPTION_ARRAY: [
    '小学1年',
    '小学2年',
    '小学3年',
    '小学4年',
    '小学5年',
    '小学6年',
    '中学1年',
    '中学2年',
    '中学3年',
    '高校1年',
    '高校2年',
    '高校3年',
    '高卒以上',
  ],
  AGE_AND_SCHOOL_OPTION_ARRAY: [
    // 児童発達
    {
      affiliation: '1',
      value: '0歳',
    },
    {
      affiliation: '1',
      value: '1歳',
    },
    {
      affiliation: '1',
      value: '2歳',
    },
    {
      affiliation: '1',
      value: '3歳',
    },
    {
      affiliation: '1',
      value: '4歳',
    },
    {
      affiliation: '1',
      value: '5歳',
    },
    {
      affiliation: '1',
      value: '6歳',
    },
    {
      affiliation: '1',
      value: '未就学児',
    },
    // 放デイ
    {
      affiliation: '0',
      value: '小学1年',
    },
    {
      affiliation: '0',
      value: '小学2年',
    },
    {
      affiliation: '0',
      value: '小学3年',
    },
    {
      affiliation: '0',
      value: '小学4年',
    },
    {
      affiliation: '0',
      value: '小学5年',
    },
    {
      affiliation: '0',
      value: '小学6年',
    },
    {
      affiliation: '0',
      value: '中学1年',
    },
    {
      affiliation: '0',
      value: '中学2年',
    },
    {
      affiliation: '0',
      value: '中学3年',
    },
    {
      affiliation: '0',
      value: '高校1年',
    },
    {
      affiliation: '0',
      value: '高校2年',
    },
    {
      affiliation: '0',
      value: '高校3年',
    },
    {
      affiliation: '0',
      value: '高卒以上',
    },
  ],
  TACKING_FLG_ARRAY: ['なし', '往路'],
  TEMPORARY_ATTENDANCE_ARRAY: ['定期利用', '追加利用'],
  TACK_OPTION_ARRAY: ['迎え不要', '迎え必要'],
  WEEK_OPTION_ARRAY: ['月', '火', '水', '木', '金', '土', '日'],
  YEAR_ARRAY: ['2020', '2021', '2022', '2023', '2024', '2025'],
  PREFECTURE_OPTION_ARRAY: [
    {
      value: '0',
      prefName: '選択してください',
    },
    {
      value: '1',
      prefName: '北海道',
    },
    {
      value: '2',
      prefName: '青森県',
    },
    {
      value: '3',
      prefName: '岩手県',
    },
    {
      value: '4',
      prefName: '宮城県',
    },
    {
      value: '5',
      prefName: '秋田県',
    },
    {
      value: '6',
      prefName: '山形県',
    },
    {
      value: '7',
      prefName: '福島県',
    },
    {
      value: '8',
      prefName: '茨城県',
    },
    {
      value: '9',
      prefName: '栃木県',
    },
    {
      value: '10',
      prefName: '群馬県',
    },
    {
      value: '11',
      prefName: '埼玉県',
    },
    {
      value: '12',
      prefName: '千葉県',
    },
    {
      value: '13',
      prefName: '東京都',
    },
    {
      value: '14',
      prefName: '神奈川県',
    },
    {
      value: '15',
      prefName: '新潟県',
    },
    {
      value: '16',
      prefName: '富山県',
    },
    {
      value: '17',
      prefName: '石川県',
    },
    {
      value: '18',
      prefName: '福井県',
    },
    {
      value: '19',
      prefName: '山梨県',
    },
    {
      value: '20',
      prefName: '長野県',
    },
    {
      value: '21',
      prefName: '岐阜県',
    },
    {
      value: '22',
      prefName: '静岡県',
    },
    {
      value: '23',
      prefName: '愛知県',
    },
    {
      value: '24',
      prefName: '三重県',
    },
    {
      value: '25',
      prefName: '滋賀県',
    },
    {
      value: '26',
      prefName: '京都府',
    },
    {
      value: '27',
      prefName: '大阪府',
    },
    {
      value: '28',
      prefName: '兵庫県',
    },
    {
      value: '29',
      prefName: '奈良県',
    },
    {
      value: '30',
      prefName: '和歌山県',
    },
    {
      value: '31',
      prefName: '鳥取県',
    },
    {
      value: '32',
      prefName: '島根県',
    },
    {
      value: '33',
      prefName: '岡山県',
    },
    {
      value: '34',
      prefName: '広島県',
    },
    {
      value: '35',
      prefName: '山口県',
    },
    {
      value: '36',
      prefName: '徳島県',
    },
    {
      value: '37',
      prefName: '香川県',
    },
    {
      value: '38',
      prefName: '愛媛県',
    },
    {
      value: '39',
      prefName: '高知県',
    },
    {
      value: '40',
      prefName: '福岡県',
    },
    {
      value: '41',
      prefName: '佐賀県',
    },
    {
      value: '42',
      prefName: '長崎県',
    },
    {
      value: '43',
      prefName: '熊本県',
    },
    {
      value: '44',
      prefName: '大分県',
    },
    {
      value: '45',
      prefName: '宮崎県',
    },
    {
      value: '46',
      prefName: '鹿児島県',
    },
    {
      value: '47',
      prefName: '沖縄県',
    },
  ],
  ROOT_ACTIVE_ARRAY: ['未使用', '使用'],
  ROOT_ARRAY: ['学校', '自宅', '自宅以外の送迎希望地点'],
  // ROOT_ARRAY: ['選択してください', '学校', '自宅', 'その他'],
  SCHOOL_OPENING_SATURDAY_ARRAY: ['全て', '第1', '第2', '第3', '第4', '第5'],
  SCHOOL_YEAR_ARRAY: ['1年', '2年', '3年', '4年', '5年', '6年'],
  SCHOOL_TYPE_ARRAY: ['小学校', '中学校', '高校'],
  SCHOOL_WEEK_ARRAY: ['月', '火', '水', '木', '金', '土'],
  UPPER_LIMIT_ARRAY: ['自社', '他社'],
  IS_DISPLAY_ARRAY: ['表示', '非表示'],

  ACHIVEMENTS_STS_ARRAY: ['未作成', '作成済み'],
  BENEFIT_STS_ARRAY: ['未作成', '作成済み'],
  INVOICE_STS_ARRAY: ['未作成', '作成済み'],
  PRE_SCHOOL_FLG_ARRAY: [
    {
      value: '0',
      areaClassLevel: ['2'],
      text: '非該当',
    },
    {
      value: '00',
      areaClassLevel: ['1', '2'],
      text: '区分１',
    },
    {
      value: '1',
      areaClassLevel: ['1'],
      text: '区分２',
    },
  ],

  // 基礎調査資料１   start
  APPLICATIONNOTEBOOK_OPTION_ARRAY: ['取得', '申請中', '未申請'],
  GENDER_OPTION_ARRAY: ['男性', '女性'],

  PRESENTSITUATION_OPTION_ARRAY: ['在宅', '入院・入所'],
  KINDOFNOTEBOOK_OPTION_ARRAY: ['身障手帳', '精神保健福祉手帳', '愛の手帳'],

  PREFECTURALANDCITY_OPTION_ARRAY: [
    {
      value: '0',
      prefName: '選択してください',
    },
    {
      value: '1',
      prefName: '県',
    },
    {
      value: '2',
      prefName: '市',
    },
  ],

  MENTALHEALTHNOTEBOOK_OPTION_ARRAY: ['1級', '2級', '3級'],
  MENTALHEALTHNOTEBOOK_SELECT_OPTION_ARRAY: [
    '選択してください',
    '1級',
    '2級',
    '3級',
  ],

  PREFECTUALANDCITY_OPTION_ARRAY: ['県', '市'],

  DISABILITYINFORMATION_OPTION_ARRAY: ['発達障害', '高次脳機能障害', 'その他'],

  LONGTERMCARE_OPTION_ARRAY: ['未申請', '非該当', '申請中'],

  HEALTHINSURANCE_OPTION_ARRAY: [
    // '選択してください',
    '国保：本人',
    '国保：家族',
    '社保：本人',
    '社保：家族',
    '医療扶助（生活保護）',
  ],

  NATIONALINSURANCE_OPTION_ARRAY: ['本人', '家族'],

  SOCIALINSURANCE_OPTION_ARRAY: ['本人', '家族'],

  MAININCOME_OPTION_ARRAY: ['給与', '年金', '労災', '生活保護', 'その他'],

  HOUSEHOLDFORM_OPTION_ARRAY: [
    '選択してください',
    '単身（一人世帯）',
    '夫婦のみ',
    '子ども世帯と同居(同一世帯・二世帯)',
    '親族と同居(親・兄弟姉妹・その他)',
    '単親世帯（ひとり親世帯）',
    'その他',
  ],

  LIVEWITHCHILD_OPTION_ARRAY: ['同一世帯', '二世帯'],

  LIVEWITHRELATIVES_OPTION_ARRAY: ['親', '兄弟姉妹', 'その他'],

  JAPANESECALENDAR_OPTION_ARRAY: ['M', 'T', 'S', 'H', 'R'],

  RELATIONSHIP_OPTION_ARRAY: [
    '選択してください',
    '本人',
    '父親',
    '母親',
    '祖父',
    '祖母',
    '兄弟姉妹',
    'その他',
  ],

  SURVIVAL_OPTION_ARRAY: ['生存', '死去'],

  WHETHERTOLIVETOGETHER_OPTION_ARRAY: ['同', '別'],
  CAREGIVER_OPTION_ARRAY: ['◎', '◯'],
  // 基礎調査資料１   stop

  // 基礎調査資料２   start
  INTERVIEWSOPPONENT_OPTION_ARRAY: [
    '選択してください',
    '本人',
    '家族',
    'その他',
  ],

  DELIVERYELAPSED_OPTION_ARRAY: ['正常', '鉗子分娩', '帝王切開'],

  FETALPOSITION_OPTION_ARRAY: ['順位', '骨盤位'],

  APPARENTDEATH_OPTION_ARRAY: ['－', '＋'],

  JAUNDICE_OPTION_ARRAY: ['軽度', '中等度', '高度'],

  SUCKLING_OPTION_ARRAY: ['良', '不良'],

  EPILEPSY_OPTION_ARRAY: ['＋', '－'],

  PLAYMATE_OPTION_ARRAY: [
    '選択してください',
    'よくできた',
    '少しできた',
    'できなかった',
  ],

  // 基礎調査資料２   stop

  // 基礎調査資料３a   start
  ROLLINGOVER_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '何かにつかまれば可',
    'できない',
  ],

  GETUP_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '何かにつかまれば可',
    'できない',
  ],

  SITTINGPOSITIONHELD_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '自分で支えれば可・支えが必要',
    'できない',
  ],

  STANDINGHOLDING_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '支えが必要',
    'できない',
  ],

  TRANSFER_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り・一部介助',
    'できない',
  ],

  ELECTRICBED_OPTION_ARRAY: ['有', '無'],

  USEOFAIRMAT_OPTION_ARRAY: ['有', '無'],

  INDOOR_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り',
    '一部介助',
    '全介助',
  ],

  OUTDOORS_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り',
    '一部介助',
    '全介助',
  ],

  TUBANDOUT_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り',
    '一部介助',
    '全介助',
  ],

  WASHING_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り',
    '一部介助',
    '全介助',
  ],

  SHAMPOO_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り',
    '一部介助',
    '全介助',
  ],

  METHOD_OPTION_ARRAY: [
    '選択してください',
    '風呂',
    'シャワー',
    '清拭',
    '入浴サービス',
  ],

  URINATION_OPTION_ARRAY: ['選択してください', '自立', '一部介助', '全介助'],

  URINATE_OPTION_ARRAY: ['選択してください', '有', '時々', '無'],

  TRANSMISSION_OPTION_ARRAY: ['可', '不可'],

  DEFECATION_OPTION_ARRAY: ['選択してください', '自立', '一部介助', '全介助'],

  BOWELMOVEMENT_OPTION_ARRAY: ['選択してください', '有', '時々', '無'],

  INCOUNTINENCE_OPTION_ARRAY: ['選択してください', '無', '時々', '常時'],

  BOWELMOVE_OPTION_ARRAY: ['選択してください', '普通', '便秘', '下痢'],

  INDIRECTSUPPORT_OPTION_ARRAY: [
    '選択してください',
    '不要',
    '部分的な支援を要する',
    '全面的な支援を要する',
  ],

  EXCRETIONMETHOD_OPTION_ARRAY: [
    '選択してください',
    '便所',
    'Pトイレ',
    '便尿器',
    'オムツ',
    'バルンカテーテル',
    'ストマ',
  ],

  DIETARYINTAKE_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り',
    '一部介助',
    '全介助',
  ],

  DRINKINGWATER_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り',
    '一部介助',
    '全介助',
  ],

  SWALLOWING_OPTION_ARRAY: ['選択してください', '自立', '見守り'],

  MEALFORM_OPTION_ARRAY: ['選択してください', '普通・軟食', 'きざみ・ミキサー'],

  USEOFSELFHELPTOOL_OPTION_ARRAY: ['有', '無'],

  USEORGANICSELFHELPTOOL_OPTION_ARRAY: [
    '選択してください',
    'スプーン',
    'フォーク',
    '箸',
    '手づかみ',
  ],

  DIET_OPTION_ARRAY: ['選択してください', '常食', '特別食'],

  REMOVABLE_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り・一部介助',
    '全介助',
  ],

  CLEANLINESS_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り・一部介助',
    '全介助',
  ],

  IADL_OPTION_ARRAY: ['選択してください', '自立', '一部介助', '全介助'],

  EYESIGHT_OPTION_ARRAY: [
    '選択してください',
    '普通',
    '1ｍ先が見える',
    '目の前が見える',
    'ほとんど見えない',
    '判断不能',
  ],

  DISABILITY_RIGHT_AND_LEFT: ['有（右）', '有（左）', '無'],

  //有無
  PRESENCEORABSENCE_OPTION_ARRAY: ['有', '無'],

  HEARING_OPTION_ARRAY: [
    '選択してください',
    '普通に聞こえる',
    'やっと聞こえる',
    'かなり大きな声なら聞こえる',
    'ほとんど聞こえない',
    '判断不能',
  ],

  //左右
  LEFTORRIGHT_OPTION_ARRAY: ['選択してください', '右', '左', '右・左'],

  //可否
  PROPRIETY_OPTION_ARRAY: ['可', '不可'],

  TRANSMISSIONOFINTENTION_OPTION_ARRAY: [
    '選択してください',
    '伝達できる',
    '時々伝達できる',
    'ほとんど伝達できない',
    '伝達できない',
  ],

  LEVELOFUNDERSTANDING_OPTION_ARRAY: [
    '選択してください',
    '特に問題なし',
    '一部相手の身振り・言葉が理解できる',
    '他者の身振り・言葉が理解できない',
  ],

  SPEAK_OPTION_ARRAY: [
    '選択してください',
    '普通に話す',
    '聞き取りにくい',
    '聞き取れない',
  ],

  WRITE_OPTION_ARRAY: [
    '選択してください',
    '書ける',
    '読み取りにくい',
    '書けない',
  ],

  READ_OPTION_ARRAY: [
    '選択してください',
    '読める（墨字）',
    '読める（点字）',
    '読めない',
  ],
  // 基礎調査資料３a   stop

  // 基礎調査資料3b   start

  AFFAIRSPROCESSING_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '見守り・声かけが時々必要 身体的一部介助',
    '見守り・声かけが常時必要 身体的全介助',
  ],

  MANIFESTATIONOFINTENTION_OPTION_ARRAY: [
    '選択してください',
    '特に問題なし',
    '一部、意思表示できる',
    '身ぶり、言葉で意思を表示できない',
  ],

  UNDERSTANDINGOFCOMMUNICATION_OPTION_ARRAY: [
    '選択してください',
    '特に問題なし',
    '一部、相手の身ぶり、言葉が理解できる',
    '他者の身ぶり、言葉が理解できない',
  ],

  EVERYDAYLIFE_OPTION_ARRAY: [
    '選択してください',
    '自立',
    '部分的な支援を要する',
    '全面的な支援を要する',
  ],

  OUTDOORMOVEMENT_OPTION_ARRAY: [
    '選択してください',
    '特に問題なし',
    '慣れたところは可',
    '常に支援が必要',
  ],

  INTERPERSONALRELATIONSANDMONEYMANAGEMENT_OPTION_ARRAY: [
    '選択してください',
    '特に問題なし',
    '一部支援が必要',
    '全面的に支援が必要',
  ],

  LETTER_OPTION_ARRAY: [
    '選択してください',
    '簡単な文章の読み書きはできる',
    '自分の名前など慣れたことの読み書きはできる',
    '文字の読み書きはできない',
  ],

  GROUP_OPTION_ARRAY: [
    '選択してください',
    '指示すれば順番を待ったり交代したりできる',
    '簡単なルールの集団活動に参加できる',
    '学校、作業所、施設、職場の規則に従って生活できる',
  ],

  TIME_OPTION_ARRAY: [
    '選択してください',
    '時計がわかる',
    '時計でおおまかな時間がわかる',
    'わからない',
  ],

  SYMBOLSELECTION_OPTION_ARRAY: ['◎', '○', '△', '×'],
  // 基礎調査資料3b   stop

  // 基礎調査資料3c   start
  NUMBERSELECTION_OPTION_ARRAY: ['1', '2', '3', '4'],

  ALPHABETSELECTION_OPTION_ARRAY: ['A', 'B', 'C', 'D'],
  // 基礎調査資料3c   stop
  // 基礎調査資料4   start

  ORAL_OPTION_ARRAY: ['選択してください', '自立', '一部介助', '全介助'],

  YES_AND_NO_OPTION_ARRAY: ['有', '無'],

  HAVEINFECTION_OPTION_ARRAY: [
    '選択してください',
    'ＭＲＳＡ',
    '疥癬',
    '結核',
    '緑膿菌',
    'その他',
  ],

  HAVEARTIFICIALTOOTH_OPTION_ARRAY: [
    '選択してください',
    '合う',
    '合わない',
    '痛む',
  ],

  SLEEP_OPTION_ARRAY: [
    '選択してください',
    '普通',
    'まあまあ眠れる',
    'あまり眠れない',
  ],

  DRINKING_OPTION_ARRAY: ['飲む', '飲まない'],

  SMOKING_OPTION_ARRAY: ['吸う', '吸わない'],

  MALADAPTIVETOTHEPOPULATION_OPTION_ARRAY: [
    '選択してください',
    'ない',
    'ときどきある',
    'ある',
  ],

  SOCIALACTIVITIESTIME_OPTION_ARRAY: [
    '選択してください',
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
  ],

  SOCIALACTIVITIESMINUTE_OPTION_ARRAY: ['選択してください', '00', '30'],
  // 基礎調査資料６   stop

  UPPER_LIMIT_CREATION_CATEGORY: [
    { value: '1', text: '新規' },
    { value: '2', text: '修正' },
    { value: '3', text: '取消' },
  ],
  UBUPPER_LIMIT_MONTHLY_AMOUNT_ARRAY: ['0', '4600', '37200'],
  BILLING_AREA_CLASS_ARRAY: [
    { value: '1', text: '1級地' },
    { value: '2', text: '2級地' },
    { value: '3', text: '3級地' },
    { value: '4', text: '4級地' },
    { value: '5', text: '5級地' },
    { value: '6', text: '6級地' },
    { value: '7', text: '7級地' },
    { value: '23', text: 'その他' },
  ],
  AREA_CLASS_LEVEL_ARRAY: [
    {
      value: '1',
      text: '主として重症心身障害児以外の障害児を通わせる場合',
    },
    { value: '2', text: '主として重症心身障害児を通わせる場合' },
  ],
  KASAN_CLASSIFICATION_ARRAY: [
    { value: '1', text: '区分1' },
    { value: '2', text: '区分2' },
  ],
  KASAN_PLACEMENT_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '専門職員（理学療法士等）の場合' },
    { value: '2', text: '児童指導員等の場合' },
    { value: '3', text: 'その他の従業者の場合' },
  ],
  KASAN_JIDOSHIDOIN_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '常勤専従・経験5年以上' },
    { value: '2', text: '常勤専従・経験5年未満' },
    { value: '3', text: '常勤換算・経験5年以上' },
    { value: '4', text: '常勤換算・経験5年未満' },
    { value: '5', text: 'その他の従業者を配置' },
  ],
  KASAN_WELFARE_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '福祉専門職員配置等加算(Ⅰ)' },
    { value: '2', text: '福祉専門職員配置等加算(Ⅱ)' },
    { value: '3', text: '福祉専門職員配置等加算(Ⅲ)' },
  ],
  KASAN_TREATMENT_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '福祉・介護職員処遇改善加算(Ⅰ)' },
    { value: '2', text: '福祉・介護職員処遇改善加算(Ⅱ)' },
    { value: '3', text: '福祉・介護職員処遇改善加算(Ⅲ)' },
    { value: '4', text: '福祉・介護職員処遇改善加算(Ⅳ)' },
    { value: '5', text: '福祉・介護職員処遇改善加算(Ⅴ)' },
  ],
  KASAN_SPECIFIC_TREATMENT_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '福祉・介護職員等特定処遇改善加算(Ⅰ)' },
    { value: '2', text: '福祉・介護職員等特定処遇改善加算(Ⅱ)' },
  ],
  KASAN_REVISION_TREATMENT_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '福祉・介護職員等処遇改善加算(Ⅰ)' },
    { value: '2', text: '福祉・介護職員等処遇改善加算(Ⅱ)' },
    { value: '3', text: '福祉・介護職員等処遇改善加算(Ⅲ)' },
    { value: '4', text: '福祉・介護職員等処遇改善加算(Ⅳ)' },
    { value: '5', text: '福祉・介護職員等処遇改善加算(Ⅴ)(1)' },
    { value: '6', text: '福祉・介護職員等処遇改善加算(Ⅴ)(2)' },
    { value: '7', text: '福祉・介護職員等処遇改善加算(Ⅴ)(3)' },
    { value: '8', text: '福祉・介護職員等処遇改善加算(Ⅴ)(4)' },
    { value: '9', text: '福祉・介護職員等処遇改善加算(Ⅴ)(5)' },
    { value: '10', text: '福祉・介護職員等処遇改善加算(Ⅴ)(6)' },
    { value: '11', text: '福祉・介護職員等処遇改善加算(Ⅴ)(7)' },
    { value: '12', text: '福祉・介護職員等処遇改善加算(Ⅴ)(8)' },
    { value: '13', text: '福祉・介護職員等処遇改善加算(Ⅴ)(9)' },
    { value: '14', text: '福祉・介護職員等処遇改善加算(Ⅴ)(10)' },
    { value: '15', text: '福祉・介護職員等処遇改善加算(Ⅴ)(11)' },
    { value: '16', text: '福祉・介護職員等処遇改善加算(Ⅴ)(12)' },
    { value: '17', text: '福祉・介護職員等処遇改善加算(Ⅴ)(13)' },
    { value: '18', text: '福祉・介護職員等処遇改善加算(Ⅴ)(14)' },
  ],
  KASAN_REVISION_VISIT_TREATMENT_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '福祉・介護職員等処遇改善加算(Ⅰ)' },
    { value: '3', text: '福祉・介護職員等処遇改善加算(Ⅲ)' },
    { value: '4', text: '福祉・介護職員等処遇改善加算(Ⅳ)' },
    { value: '5', text: '福祉・介護職員等処遇改善加算(Ⅴ)(1)' },
    { value: '6', text: '福祉・介護職員等処遇改善加算(Ⅴ)(2)' },
    { value: '9', text: '福祉・介護職員等処遇改善加算(Ⅴ)(5)' },
    { value: '11', text: '福祉・介護職員等処遇改善加算(Ⅴ)(7)' },
    { value: '12', text: '福祉・介護職員等処遇改善加算(Ⅴ)(8)' },
    { value: '14', text: '福祉・介護職員等処遇改善加算(Ⅴ)(10)' },
    { value: '15', text: '福祉・介護職員等処遇改善加算(Ⅴ)(11)' },
    { value: '17', text: '福祉・介護職員等処遇改善加算(Ⅴ)(13)' },
    { value: '18', text: '福祉・介護職員等処遇改善加算(Ⅴ)(14)' },
  ],
  SEVERE_CHILD_ARRAY: [
    { value: '0', text: '非該当' },
    { value: '1', text: '該当' },
  ],
  SPECIAL_PLAN_ARRAY: [
    { value: '0', text: '非該当' },
    { value: '1', text: '該当' },
  ],
  FREE_CHARGE_ARRAY: [
    { value: '0', text: '非該当' },
    { value: '1', text: '該当' },
  ],
  MANY_CHILDREN_NO_ARRAY: [
    { value: '1', text: '第一子' },
    { value: '2', text: '第二子' },
    { value: '3', text: '第三子以降' },
  ],
  MEDICAL_CARE_CHILD_ARRAY: [
    { value: '0', text: '非該当' },
    { value: '3', text: '医療的ケア児Ⅰ' }, //サービスコード表にあわせているため、valueは3としているサービスコード表は医療的ケア区分Ⅰが（三）になっているため
    { value: '2', text: '医療的ケア児Ⅱ' },
    { value: '1', text: '医療的ケア児Ⅲ' }, //サービスコード表にあわせているため、valueは1としているサービスコード表は医療的ケア区分Ⅲが（一）になっているため
  ],
  MEDICAL_CARE_CHILD_TOOLTIP_OBJ: {
    tooltipTextArray: [
      {
        tooltipText: `受給者証にある医療的ケア判定スコアをもとに医療的ケア児の設定をしてください。\n医療的ケア児に該当しない・・・非該当、スコア３点以上・・・医療的ケア児Ⅰ、１６点以上・・・医療的ケア児Ⅱ、３２点以上・・・医療的ケア児Ⅲ`,
      },
    ],
    tooltipTextLink: '[医療的ケア児について]',
    tooltipTitle: '',
  },
  JIHATSU_KASAN_SPECIALTY_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '専門職員（理学療法士等）の場合' },
    { value: '2', text: '児童指導員等の場合' },
  ],

  AFFILIATION_ARRAY: [
    {
      value: '1',
      text: '児童発達',
    },
    {
      value: '0',
      text: '放デイ',
    },
    {
      value: '2',
      text: '保訪',
    },
  ],
  AFFILIATION_TUSYO_ARRAY: [
    {
      value: '1',
      text: '児童発達',
    },
    {
      value: '0',
      text: '放デイ',
    },
  ],
  AFFILIATION_HOMON_ARRAY: [
    {
      value: '2',
      text: '保訪',
    },
  ],
  AFFILIATION_SODAN_ARRAY: [
    {
      value: '3',
      text: '相談',
    },
  ],
  AFFILIATION_CENTER_OBJ: {
    value: '1',
    text: 'センター',
  },
  AFFILIATION_GOVERNMENT_OBJ: {
    value: '1',
    text: '地方公共団体',
  },
  AFFILIATION_SODAN_OBJ: {
    value: '1',
    text: '相談',
  },
  AFFILIATION_ICON_ARRAY: [
    {
      value: '1',
      text: '児',
    },
    {
      value: '0',
      text: '放',
    },
    {
      value: '2',
      text: '保',
    },
  ],
  AFFILIATION_TYPE_ICON_ARRAY: [
    {
      value: '1',
      text: '児',
    },
    {
      value: '0',
      text: '放',
    },
    {
      value: '2',
      text: '保',
    },
    {
      value: '3',
      text: '相',
    },
  ],
  AFFILIATION_FILTER_ARRAY: [
    {
      value: '1',
      label: '児発',
      iconText: '児',
      colorType: '--warning',
    },
    {
      value: '0',
      label: '放デイ',
      iconText: '放',
      colorType: '--info',
    },
    {
      value: '2',
      label: '保訪',
      iconText: '保',
      colorType: '--pink',
    },
    {
      value: '3',
      label: '相談',
      iconText: '相',
      colorType: '--dark',
    },
  ],
  ACTIVE_FILTER_ARRAY: [
    {
      value: 2,
      label: '仮登録',
      iconText: '仮',
      colorType: '--warning-dark',
    },
    {
      value: 1,
      label: '在籍中',
      iconText: '在',
      colorType: '--success',
    },
    {
      value: 0,
      label: '退所',
      iconText: '退',
      colorType: '--secondary-dark',
    },
  ],

  PROVISION_FORM_ARRAY: [
    {
      value: '0',
      label: '開業日',
    },
    {
      value: '1',
      label: '休業日',
    },
  ],
  ALTERNATIVE_SUPPORT_ARRAY: [
    { value: '0', label: 'なし' },
    { value: '1', label: 'あり' },
  ],
  MULTIPLE_ADDITION_CHECK_ARRAY: [
    { value: '1', label: '加算Ⅰ', additionKey: '1' },
    { value: '1', label: '加算II', additionKey: '2' },
  ],
  MULTIPLE_ADDITION_CHECK_REVISION_2024_ARRAY: [
    { value: 1, label: '加算Ⅰ', additionKey: '1' },
    { value: 1, label: '加算II', additionKey: '2' },
    { value: 1, label: '加算III', additionKey: '3' },
    { value: 1, label: '加算IV', additionKey: '4' },
  ],
  ONE_ADDITION_MULTIPLE_CHECK_ARRAY: [
    { value: '1', label: '加算Ⅰ' },
    { value: '2', label: '加算II' },
  ],
  ONE_ADDITION_3_MULTIPLE_CHECK_ARRAY: [
    { value: '1', label: '加算Ⅰ' },
    { value: '2', label: '加算II' },
    { value: '3', label: '加算III' },
  ],
  AVAILABLE_ARRAY: [
    { value: 0, label: 'なし' },
    { value: 1, label: 'あり' },
  ],
  STR_AVAILABLE_ARRAY: [
    { value: '0', label: 'なし' },
    { value: '1', label: 'あり' },
  ],
  ACHIVEMENTS_KASAN_KEY_ARRAY: [
    'homeAddition',
    'homeAdditionStartHour',
    'homeAdditionStartMinute',
    'homeAdditionEndHour',
    'homeAdditionEndMinute',
    'medicalCooperation',
    'medicalCooperationStartHour',
    'medicalCooperationStartMinute',
    'medicalCooperationEndHour',
    'medicalCooperationEndMinute',
    'organizationAddition',
    'organizationAdditionStartHour',
    'organizationAdditionStartMinute',
    'organizationAdditionEndHour',
    'organizationAdditionEndMinute',
    'organizationAddition2',
    'organizationAddition2StartHour',
    'organizationAddition2StartMinute',
    'organizationAddition2EndHour',
    'organizationAddition2EndMinute',
    'consultationAddition',
    'consultationAdditionStartHour',
    'consultationAdditionStartMinute',
    'consultationAdditionEndHour',
    'consultationAdditionEndMinute',
    'consultationAddition2',
    'consultationAddition2StartHour',
    'consultationAddition2StartMinute',
    'consultationAddition2EndHour',
    'consultationAddition2EndMinute',
    'kasanStrength',
    'kasanExtended',
    'kasanFirst',
  ],
  ACHIVEMENTS_REVISION_2024_KASAN_KEY_ARRAY: [
    'medicalCooperation',
    'medicalCooperationStartHour',
    'medicalCooperationStartMinute',
    'medicalCooperationEndHour',
    'medicalCooperationEndMinute',
    'organizationAddition',
    'organizationAdditionStartHour',
    'organizationAdditionStartMinute',
    'organizationAdditionEndHour',
    'organizationAdditionEndMinute',
    'organizationAddition2',
    'organizationAddition2StartHour',
    'organizationAddition2StartMinute',
    'organizationAddition2EndHour',
    'organizationAddition2EndMinute',
    'organizationAddition3',
    'organizationAddition3StartHour',
    'organizationAddition3StartMinute',
    'organizationAddition3EndHour',
    'organizationAddition3EndMinute',
    'organizationAddition4',
    'organizationAddition4StartHour',
    'organizationAddition4StartMinute',
    'organizationAddition4EndHour',
    'organizationAddition4EndMinute',
    'calculationTime',
    'kasanStrength',
    'kasanExtended',
    'kasanTsushoJiritsu',
    'kasanNyuyoku',
    'kasanKinoShogaiji',
    'kasanKazokuShien1',
    'kasanKazokuShien2',
    'kasanKazokuShien',
    'kasanKazokuShienStartHour',
    'kasanKazokuShienStartMinute',
    'kasanKazokuShienEndHour',
    'kasanKazokuShienEndMinute',
    'kasanKazokuShienPlace',
    'kasanKazokuShien1StartHour',
    'kasanKazokuShien1StartMinute',
    'kasanKazokuShien1EndHour',
    'kasanKazokuShien1EndMinute',
    'kasanKazokuShien1Place',
    'kasanKazokuShien2StartHour',
    'kasanKazokuShien2StartMinute',
    'kasanKazokuShien2EndHour',
    'kasanKazokuShien2EndMinute',
    'kasanKazokuShien2Place',
    'kasanKosodateSupport',
    'kasanSenmontekiJisshi',
    'kasanShuchu',
    'kasanJigyoshokan',
    'kasanJiritsuSupport',
    'kasanIkoShien',
    'kasanHomonShien',
    'kasanTashugyo',
    'kasanCareNeeds',
    'kasanFirst',
  ],
  ACHIVEMENTS_REVISION_2024_KASAN_TIME_KEY_ARRAY: [
    'medicalCooperation',
    'organizationAddition',
    'organizationAddition2',
    'organizationAddition3',
    'organizationAddition4',
    'kasanKazokuShien',
  ],

  HOME_ADDITION_KEY_ARRAY: ['homeAddition', 'jihatsuHomeAddition'],
  CONSULTATION_ADDITION_KEY_ARRAY: [
    'consultationAddition',
    'consultationAddition2',
    'jihatsuConsultationAddition',
    'jihatsuConsultationAddition2',
  ],
  ACHIVEMENTS_KASAN_KEY_TEXT_ARRAY: [
    {
      key: 'home_addition',
      text: '家庭連携加算',
    },
    {
      key: 'medical_cooperation',
      text: '医療連携体制加算',
    },
    {
      key: 'organization_addition',
      text: '関係機関連携加算Ⅰ',
    },
    {
      key: 'organization_addition2',
      text: '関係機関連携加算Ⅱ',
    },
    {
      key: 'consultation_addition',
      text: '事業所内相談支援加算Ⅰ',
    },
    {
      key: 'consultation_addition2',
      text: '事業所内相談支援加算Ⅱ',
    },
  ],
  ACHIVEMENTS_REVISION_2024_KASAN_KEY_TEXT_ARRAY: [
    {
      key: 'kasan_kazoku_shien1',
      text: '家族支援加算Ⅰ',
    },
    {
      key: 'kasan_kazoku_shien2',
      text: '家族支援加算Ⅱ',
    },
    {
      key: 'kasan_kazoku_shien',
      text: '家族支援加算',
    },
    {
      key: 'medical_cooperation',
      text: '医療連携体制加算',
    },
    {
      key: 'organization_addition',
      text: '関係機関連携加算Ⅰ',
    },
    {
      key: 'organization_addition2',
      text: '関係機関連携加算Ⅱ',
    },
    {
      key: 'organization_addition3',
      text: '関係機関連携加算Ⅲ',
    },
    {
      key: 'organization_addition4',
      text: '関係機関連携加算Ⅳ',
    },
  ],
  ATTENDANCE_TYPE_ARRAY: [
    '欠席',
    '出席',
    'お休み',
    '追加利用の申請中',
    '欠席の申請中',
    'お休みの申請中',
    '',
    '',
    '欠席2',
    '',
  ],
  AT_FLG_VALUE_OBJ_ARRAY: [
    {
      atFlg: 1,
    },
    {
      atFlg: 0,
    },
    {
      atFlg: 2,
    },
    {
      atFlg: 3,
    },
    {
      atFlg: 4,
    },
    {
      atFlg: 5,
    },
  ],
  COME_TYPE_ARRAY: [
    {
      value: '0',
      label: '自分で来る',
    },
    {
      value: '1',
      label: 'お迎え',
    },
  ],
  RETURN_TYPE_ARRAY: [
    {
      value: '0',
      label: '自分で帰る',
    },
    {
      value: '1',
      label: '送り',
    },
  ],
  STAFF_ROLE_ARRAY: [
    {
      value: 0,
      label: '一般',
    },
    {
      value: 1,
      label: '管理者',
    },
  ],
  STAFF_AFFILIATION_ARRAY: [
    {
      value: '1',
      label: '児童発達支援',
    },
    {
      value: '0',
      label: '放課後等デイサービス',
    },
  ],
  STAFF_ATTENDANCE_ARRAY: [
    {
      value: '',
      label: 'なし',
    },
    {
      value: '1',
      label: '出勤',
    },
    {
      value: '2',
      label: '有給',
    },
    {
      value: '0',
      label: '公休',
    },
  ],
  UB_CLD_UPPER_LIMIT_NUMBER: [2, 3, 4],
  UB_SET_KEY_ARRAY: [
    'ubOfficeNumber',
    'ubCldUpperLimitNumber',
    'ubBeneficiaryId',
    'ubOfficeName',
    'ubTotalCost',
    'ubCost',
    'ubAfterCost',
  ],
  HOLIDAY_TYPE: ['営業日', '休業日'],
  HOLIDAY_OMIT_TYPE: ['営', '休'],
  ACHIEVEMENTS_FILTER_OPTION_ATTENDANCE_ARRAY: [
    {
      value: '0',
      text: '全て',
    },
    {
      value: '1',
      text: '出席',
    },
    {
      value: '2',
      text: '出席以外',
    },
  ],
  ACHIEVEMENTS_FILTER_OPTION_STATUS_ARRAY: [
    {
      value: '0',
      text: '全て',
    },
    {
      value: '1',
      text: '未作成',
    },
    {
      value: '2',
      text: '作成済み',
    },
  ],
  ACHIEVEMENTS_FILTER_OPTION_AFFILIATION_ARRAY: [
    {
      value: '0',
      text: '全て',
      searchValue: '',
    },
    {
      value: '1',
      text: '児童発達',
      searchValue: '1',
    },
    {
      value: '2',
      text: '放デイ',
      searchValue: '0',
    },
  ],
  PRINT_FILTER_OPTION_AFFILIATION_ARRAY: [
    {
      value: '0',
      text: '全て',
      searchValue: '',
    },
    {
      value: '1',
      text: '児童発達',
      searchValue: '1',
    },
    {
      value: '2',
      text: '放デイ',
      searchValue: '0',
    },
    {
      value: '3',
      text: '保訪',
      searchValue: '2',
    },
  ],
  ATTENDANCE_SELECT_ARRAY: [
    {
      value: '',
      text: 'なし',
    },
    {
      value: 0,
      text: '欠席',
    },
    {
      value: 1,
      text: '出席',
    },
    {
      value: 2,
      text: 'お休み',
    },
  ],
  TEMPORARY_SELECT_ARRAY: [
    {
      value: '',
      text: 'なし',
    },
    {
      value: 0,
      text: '定期',
    },
    {
      value: 1,
      text: '追加',
    },
  ],
  ACHIEVEMENTS_ADDITION_KEY_ARRAY: [
    { key: 'homeAddition', label: '家庭連携加算' },
    { key: 'organizationAddition', label: '関係機関連携加算Ⅰ' },
    { key: 'organizationAddition2', label: '関係機関連携加算Ⅱ' },
    { key: 'medicalCooperation', label: '医療体制連携加算' },
    { key: 'consultationAddition', label: '事業所内相談支援加算Ⅰ' },
    { key: 'consultationAddition2', label: '事業所内相談支援加算Ⅱ' },
  ],
  ACHIEVEMENTS_REVISION_2024_ADDITION_KEY_ARRAY: [
    { key: 'homeAddition', label: '家庭連携加算' },
    { key: 'organizationAddition', label: '関係機関連携加算Ⅰ' },
    { key: 'organizationAddition2', label: '関係機関連携加算Ⅱ' },
    { key: 'organizationAddition3', label: '関係機関連携加算Ⅲ' },
    { key: 'organizationAddition4', label: '関係機関連携加算Ⅳ' },
    { key: 'medicalCooperation', label: '医療体制連携加算' },
    { key: 'kasanKazokuShien1', label: '家族支援加算Ⅰ' },
    { key: 'kasanKazokuShien2', label: '家族支援加算Ⅱ' },
    { key: 'kasanTsushoJiritsu', label: '通所自立支援加算' },
    { key: 'kasanNyuyoku', label: '入浴支援加算' },
    { key: 'kasanKosodateSupport', label: '子育てサポート加算' },
    { key: 'kasanJiritsuSupport', label: '自立サポート加算' },
    { key: 'kasanJigyoshokan', label: '事業所間連携加算' },
    { key: 'kasanKinoShogaiji', label: '視覚・聴覚・言語機能障害児支援加算' },
    { key: 'kasanIkoShien', label: '保育・教育等移行支援加算' },
    { key: 'consultationAddition', label: '事業所内相談支援加算Ⅰ' },
    { key: 'consultationAddition2', label: '事業所内相談支援加算Ⅱ' },
  ],
  ACHIEVEMENTS_REVISION_2024_ADDITION_VALID_TIME_KEY_ARRAY: [
    // { key: 'homeAddition', label: '家庭連携加算' },
    { key: 'organizationAddition', label: '関係機関連携加算Ⅰ' },
    { key: 'organizationAddition2', label: '関係機関連携加算Ⅱ' },
    { key: 'organizationAddition3', label: '関係機関連携加算Ⅲ' },
    { key: 'organizationAddition4', label: '関係機関連携加算Ⅳ' },
    { key: 'medicalCooperation', label: '医療体制連携加算' },
    { key: 'kasanKazokuShien1', label: '家族支援加算Ⅰ' },
    { key: 'kasanKazokuShien2', label: '家族支援加算Ⅱ' },
    // { key: 'consultationAddition', label: '事業所内相談支援加算Ⅰ' },
    // { key: 'consultationAddition2', label: '事業所内相談支援加算Ⅱ' },
  ],

  // 放デイ
  HOUDAY_AFFILIATION: '0',
  // 児発
  JIHATSU_AFFILIATION: '1',
  // 保訪
  HOHOU_AFFILIATION: '2',
  // 相談支援
  SODAN_AFFILIATION: '3',
  CHILD_ADDITION_KEY_ARRAY: [
    { key: 'kasanSpecial', label: '特別支援加算' },
    { key: 'kasanStrength', label: '強度行動障害児支援加算' },
    { key: 'kasanSupport1', label: '個別サポート加算Ⅰ' },
    { key: 'kasanSupport2', label: '個別サポート加算Ⅱ' },
    { key: 'kasanCare', label: '保育・教育等移行支援加算' },
    { key: 'kasanNursing1', label: '看護職員加配加算' },
    { key: 'kasanNursing2', label: '看護職員加配加算' },
    { key: 'kasanDayUpper', label: '上限管理加算' },
  ],
  CHILD_ADDITION_KEY_ADD_ARRAY: [
    { key: 'kasanSpecial', label: '特別支援加算' },
    { key: 'kasanSupport1', label: '個別サポート加算Ⅰ' },
    { key: 'kasanSupport2', label: '個別サポート加算Ⅱ' },
    { key: 'kasanSupport3', label: '個別サポート加算Ⅲ' },
    { key: 'kasanTsushoJiritsu', label: '通所自立支援加算' },
    { key: 'kasanNursing1', label: '看護職員加配加算' },
    { key: 'kasanNursing2', label: '看護職員加配加算' },
    { key: 'kasanDayUpper', label: '上限管理加算' },
    { key: 'kasanJinkoNaiji', label: '人工内耳装用児支援加算' },
    { key: 'kasanKinoShogaiji', label: '視覚・聴覚・言語機能障害児支援加算' },
    { key: 'visitKasanCareNeeds', label: 'ケアニーズ対応加算' },
    { key: 'kasanKyoseiIryoteki', label: '共生型サービス医療的ケア児支援加算' },
  ],
  CHILD_VISIT_ADDITION_KEY_ADD_ARRAY: [
    { key: 'visitKasanCareNeeds', label: 'ケアニーズ対応加算' },
  ],
  CHILD_KASAN_STRENGTH_ARRAY: [
    { key: 'jihatsuKasanStrength', label: '児発・保訪' },
    { key: 'kasanKyodoKodo', label: '放デイ' },
  ],
  CHILD_KASAN_STRENGTH_DATE_ARRAY: [
    { key: 'kasanKyodoKodoStartDate', label: '強行の開始日' },
    { key: 'jihatsuKasanKyodoKodoStartDate', label: '強行の開始日' },
  ],
  CHILD_ADDITION_DATE_LABEL_ARRAY: [
    '保育・教育等移行支援加算',
    '集中的支援加算',
  ],
  CHILD_ADDITION_DATE_KEY_ARRAY: [
    { key: 'kasanCareTransferDate', label: '移行日' },
    { key: 'kasanCareCalculationDate', label: '移行後算定日' },
    { key: 'kasanShuchuStartDate', label: '支援開始日' },
  ],
  BULK_PRINT_OPTION_ARRAY: [
    {
      value: '1',
      text: 'サービス提供実績記録票',
      description: '実績記録が作成済みの児童が表示されております。',
      printTarget: 'achivements',
    },
    {
      value: '2',
      text: '障害児通所給付費・入所給付費等明細書（様式第二）',
      description: '給付費明細が作成済み・結果待ちの児童が表示されております。',
      printTarget: 'details',
    },
    {
      value: '3',
      text: '利用者負担上限額管理結果票',
      description:
        '上限管理結果票が作成済み・結果待ちの上限管理が自社の児童が表示されております。別の児童にきょうだい上限管理されている児童は表示されません。',
      printTarget: 'upperLimit',
    },
    {
      value: '4',
      text: '利用者負担額一覧表',
      description:
        '給付費明細（様式第二）が作成済み・結果待ちの上限管理が他社の児童が表示されております。',
      printTarget: 'userBurdens',
    },
    {
      value: '5',
      text: '利用料明細 / 請求書',
      description:
        '利用料明細 / 請求書・領収書が作成済みの児童が表示されております。',
      printTarget: 'parentsDetailsSelect',
    },
    {
      value: '6',
      text: '利用料明細 / 領収書',
      description:
        '利用料明細 / 請求書・領収書が作成済みの児童が表示されております。',
      printTarget: 'parentsDetailsPrev',
    },
    {
      value: '7',
      text: '代理受領額通知書',
      description:
        '代理受領額通知書（給付費明細（様式第二））が作成済み・結果待ちの児童が表示されております。',
      printTarget: 'proxyDetails',
    },
    {
      value: '8',
      text: '障害児通所給付費・入所給付費等請求書（様式第一）',
      description: '',
      printTarget: 'summary',
    },
  ],
  VARIABLE_SERVICE_CODE: [
    '6621',
    '6616',
    '6596',
    '6601',
    '6606',
    '6611',
    '6771',
    '6772',
    '6773',
    '6766',
    'Z001',
    'ZZ01',
    '6770',
  ],
  VARIABLE_NEW_SERVICE_CODE: [
    '6621',
    '6616',
    '6596',
    '6601',
    '6606',
    '6611',
    '6771',
    '6772',
    '6773',
    '6766',
    // 'Z001',
    'ZZ01',
    '6770',
    // 減算
    'Z031',
    'Z051',
    'Z061',
    'Z081',
    // 処遇改善
    '5621',
    '5622',
    '5623',
    '5624',
    '5625',
    '5626',
    '5627',
    '5628',
    '5629',
    '5630',
    '5631',
    '5632',
    '5633',
    '5634',
    '5635',
    '5636',
    '5637',
    '5638',
  ],
  RESET_VALUE_BY_HOHOU: [
    {
      key: 'visitContractDate',
      value: '',
    },
    {
      key: 'visitContractEndDate',
      value: '',
    },
    {
      key: 'visitStartUsingDate',
      value: '',
    },
    {
      key: 'visitEndUsingDate',
      value: '',
    },
    {
      key: 'visitPaymentAmount',
      value: '',
    },
    {
      key: 'visitContractAmount',
      value: '',
    },
    {
      key: 'visitBeneficiaryEntryFieldNo',
      value: '',
    },
  ],
  RESET_VALUE_BY_SODAN: [
    {
      key: 'sodanContractDate',
      value: '',
    },
    {
      key: 'sodanContractEndDate',
      value: '',
    },
  ],
  RESET_VALUE_BY_TUSYO: [
    {
      key: 'startUsingDate',
      value: '',
    },
    {
      key: 'endUsingDate',
      value: '',
    },
    {
      key: 'beneficiaryEntryFieldNo',
      value: '',
    },
    {
      key: 'contractDate',
      value: '',
    },
    {
      key: 'contractEndDate',
      value: '',
    },
    {
      key: 'contractAmount',
      value: '',
    },
    {
      key: 'paymentAmount',
      value: '',
    },
    {
      key: 'attendance',
      value: {
        '1': 'False',
        '2': 'False',
        '3': 'False',
        '4': 'False',
        '5': 'False',
        '6': 'False',
        '7': 'False',
      },
    },
    {
      key: 'settingPickFlg',
      value: '0',
    },
    {
      key: 'settingSendFlg',
      value: '0',
    },
  ],
  CONTRACT_AND_START_USING_DATE: [
    'contractDate',
    'startUsingDate',
    'visitContractDate',
    'visitStartUsingDate',
  ],
  DISCRIMINATION_AFFILIATION: {
    '0': false,
    '1': false,
  },
  HOHOU_ATTENDANCE_TYPE_ARRAY: [
    '実施キャンセル',
    '実施',
    '実施キャンセル申請中',
  ],
  HOHOU_ATTENDANCE_TYPE_RADIO_ARRAY: [
    { label: '実施', value: 1 },
    { label: '実施キャンセル', value: 0 },
  ],
  ADDITION_NORMAL_FLG: [
    { label: 'なし', value: '0' },
    { label: 'あり', value: '1' },
  ],
  VISIT_KEY_DEFAULT_ARRAY: [
    { key: 'comeTimeHour', value: '00' },
    { key: 'comeTimeMinute', value: '00' },
    { key: 'returnTimeHour', value: '00' },
    { key: 'returnTimeMinute', value: '00' },
    { key: 'reasonForAbsence', value: [] },
    { key: 'manager', value: '' },
    { key: 'leader', value: '' },
    { key: 'kasanFirst', value: '0' },
    { key: 'isMultiple', value: '0' },
    { key: 'kasanSpecialArea', value: '0' },
    { key: 'remarks', value: '' },
    { key: 'kasanWelfare', value: '0' },
  ],
  SERVICE_CODE_TYPE_AND_AFFILIATION_ARRAY: [
    {
      serviceCodeType: '63',
      affiliation: '0',
      serviceName: '放課後等デイサービス',
    },
    {
      serviceCodeType: '61',
      affiliation: '1',
      serviceName: '児童発達支援',
    },
    {
      serviceCodeType: '64',
      affiliation: '2',
      serviceName: '保育所等訪問支援',
    },
  ],
  VISIT_SNAKE_KEY_ARRAY: [
    'come_time_hour',
    'come_time_minute',
    'return_time_hour',
    'return_time_minute',
    // 'kasan_first',
    'kasan_special_area',
    'kasan_welfare',
    'manager_name',
    // 'leader_name',
    'is_multiple',
  ],
  FREE_OF_CHARGE_AND_MANY_CHILD_TARGET_SERVICE_CODE_TYPE_ARRAY: ['61', '64'],
  OFFICE_CREATION_CATEGORY_TOOLTIP_ARRAY: [
    {
      tooltipText:
        '選択は毎回、未選択になりますので一括変更したい場合、都度選択してください。',
    },
    {
      tooltipText:
        '※作成区分は、再請求・返戻時に行政から送付された書面をご確認ください。',
    },
  ],
  APP_INFO: {
    appName: 'デイロボ',
    appOfficeName: 'U5WORKS Inc.',
    appOfficeUrl: 'https://u5works.co.jp/',
    appOfficeSupportAddress: 'support@dayrobo.com',
  },
  KASAN_EXTENDED_INPUT_ARRAY: [
    {
      label: '選択してください',
      value: '0',
    },
    {
      label: '1時間未満',
      value: '1',
    },
    {
      label: '1時間以上2時間未満',
      value: '2',
    },
    {
      label: '2時間以上',
      value: '3',
    },
  ],
  KASAN_NEW_EXTENDED_INPUT_ARRAY: [
    { value: '0', label: '選択してください' },
    { value: '1', label: '30分以上1時間未満' },
    { value: '2', label: '1時間以上2時間未満' },
    { value: '3', label: '2時間以上' },
  ],
  KASAN_KAZOKU_SHIEN_PLACE_INPUT_ARRAY: [
    { value: '0', label: '選択してください' },
    { value: '1', label: '居宅訪問' },
    { value: '2', label: '事業所' },
    { value: '3', label: 'オンライン' },
  ],
  KASAN_KAZOKU_SHIEN_PLACE_INPUT_TEXT_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '1', text: '居宅訪問' },
    { value: '2', text: '事業所' },
    { value: '3', text: 'オンライン' },
  ],
  KASAN_KAZOKU_SHIEN_2_PLACE_INPUT_TEXT_ARRAY: [
    { value: '0', text: '選択してください' },
    { value: '2', text: '事業所' },
    { value: '3', text: 'オンライン' },
  ],
  KASAN_IKO_SHIEN_INPUT_ARRAY: [
    { value: '0', label: '選択してください' },
    { value: '1', label: '退所前に移行に向けた取組を行った場合' },
    { value: '2', label: '退所後に居宅等を訪問して相談援助を行った場合' },
    { value: '3', label: '保育所等を訪問して助言・援助を行った場合' },
  ],
  CALCULATION_TIME_INPUT_ARRAY: [
    { value: '0', label: '0分' },
    { value: '0.08', label: '5分' },
    { value: '0.17', label: '10分' },
    { value: '0.25', label: '15分' },
    { value: '0.33', label: '20分' },
    { value: '0.42', label: '25分' },
    { value: '0.5', label: '30分' },
    { value: '0.58', label: '35分' },
    { value: '0.67', label: '40分' },
    { value: '0.75', label: '45分' },
    { value: '0.83', label: '50分' },
    { value: '0.92', label: '55分' },
    { value: '1', label: '1時間' },
    { value: '1.08', label: '1時間5分' },
    { value: '1.17', label: '1時間10分' },
    { value: '1.25', label: '1時間15分' },
    { value: '1.33', label: '1時間20分' },
    { value: '1.42', label: '1時間25分' },
    { value: '1.5', label: '1時間30分' },
    { value: '1.58', label: '1時間35分' },
    { value: '1.67', label: '1時間40分' },
    { value: '1.75', label: '1時間45分' },
    { value: '1.83', label: '1時間50分' },
    { value: '1.92', label: '1時間55分' },
    { value: '2', label: '2時間' },
    { value: '2.08', label: '2時間5分' },
    { value: '2.17', label: '2時間10分' },
    { value: '2.25', label: '2時間15分' },
    { value: '2.33', label: '2時間20分' },
    { value: '2.42', label: '2時間25分' },
    { value: '2.5', label: '2時間30分' },
    { value: '2.58', label: '2時間35分' },
    { value: '2.67', label: '2時間40分' },
    { value: '2.75', label: '2時間45分' },
    { value: '2.83', label: '2時間50分' },
    { value: '2.92', label: '2時間55分' },
    { value: '3', label: '3時間' },
    { value: '3.08', label: '3時間5分' },
    { value: '3.17', label: '3時間10分' },
    { value: '3.25', label: '3時間15分' },
    { value: '3.33', label: '3時間20分' },
    { value: '3.42', label: '3時間25分' },
    { value: '3.5', label: '3時間30分' },
    { value: '3.58', label: '3時間35分' },
    { value: '3.67', label: '3時間40分' },
    { value: '3.75', label: '3時間45分' },
    { value: '3.83', label: '3時間50分' },
    { value: '3.92', label: '3時間55分' },
    { value: '4', label: '4時間' },
    { value: '4.08', label: '4時間5分' },
    { value: '4.17', label: '4時間10分' },
    { value: '4.25', label: '4時間15分' },
    { value: '4.33', label: '4時間20分' },
    { value: '4.42', label: '4時間25分' },
    { value: '4.5', label: '4時間30分' },
    { value: '4.58', label: '4時間35分' },
    { value: '4.67', label: '4時間40分' },
    { value: '4.75', label: '4時間45分' },
    { value: '4.83', label: '4時間50分' },
    { value: '4.92', label: '4時間55分' },
    { value: '5', label: '5時間' },
    { value: '5.08', label: '5時間5分' },
    { value: '5.17', label: '5時間10分' },
    { value: '5.25', label: '5時間15分' },
    { value: '5.33', label: '5時間20分' },
    { value: '5.42', label: '5時間25分' },
    { value: '5.5', label: '5時間30分' },
    { value: '5.58', label: '5時間35分' },
    { value: '5.67', label: '5時間40分' },
    { value: '5.75', label: '5時間45分' },
    { value: '5.83', label: '5時間50分' },
    { value: '5.92', label: '5時間55分' },
    { value: '6', label: '6時間' },
    { value: '6.08', label: '6時間5分' },
    { value: '6.17', label: '6時間10分' },
    { value: '6.25', label: '6時間15分' },
    { value: '6.33', label: '6時間20分' },
    { value: '6.42', label: '6時間25分' },
    { value: '6.5', label: '6時間30分' },
    { value: '6.58', label: '6時間35分' },
    { value: '6.67', label: '6時間40分' },
    { value: '6.75', label: '6時間45分' },
    { value: '6.83', label: '6時間50分' },
    { value: '6.92', label: '6時間55分' },
    { value: '7', label: '7時間' },
  ],

  CALCULATION_TIME_ARRAY: [
    { value: '0,', label: ['0', '0'] },
    { value: '0.08', label: ['0', '5'] },
    { value: '0.17', label: ['0', '10'] },
    { value: '0.25', label: ['0', '15'] },
    { value: '0.33', label: ['0', '20'] },
    { value: '0.42', label: ['0', '25'] },
    { value: '0.5', label: ['0', '30'] },
    { value: '0.58', label: ['0', '35'] },
    { value: '0.67', label: ['0', '40'] },
    { value: '0.75', label: ['0', '45'] },
    { value: '0.83', label: ['0', '50'] },
    { value: '0.92', label: ['0', '55'] },
    { value: '1', label: ['1', '0'] },
    { value: '1.08', label: ['1', '5'] },
    { value: '1.17', label: ['1', '10'] },
    { value: '1.25', label: ['1', '15'] },
    { value: '1.33', label: ['1', '20'] },
    { value: '1.42', label: ['1', '25'] },
    { value: '1.5', label: ['1', '30'] },
    { value: '1.58', label: ['1', '35'] },
    { value: '1.67', label: ['1', '40'] },
    { value: '1.75', label: ['1', '45'] },
    { value: '1.83', label: ['1', '50'] },
    { value: '1.92', label: ['1', '55'] },
    { value: '2', label: ['2', '0'] },
    { value: '2.08', label: ['2', '5'] },
    { value: '2.17', label: ['2', '10'] },
    { value: '2.25', label: ['2', '15'] },
    { value: '2.33', label: ['2', '20'] },
    { value: '2.42', label: ['2', '25'] },
    { value: '2.5', label: ['2', '30'] },
    { value: '2.58', label: ['2', '35'] },
    { value: '2.67', label: ['2', '40'] },
    { value: '2.75', label: ['2', '45'] },
    { value: '2.83', label: ['2', '50'] },
    { value: '2.92', label: ['2', '55'] },
    { value: '3', label: ['3', '0'] },
    { value: '3.08', label: ['3', '5'] },
    { value: '3.17', label: ['3', '10'] },
    { value: '3.25', label: ['3', '15'] },
    { value: '3.33', label: ['3', '20'] },
    { value: '3.42', label: ['3', '25'] },
    { value: '3.5', label: ['3', '30'] },
    { value: '3.58', label: ['3', '35'] },
    { value: '3.67', label: ['3', '40'] },
    { value: '3.75', label: ['3', '45'] },
    { value: '3.83', label: ['3', '50'] },
    { value: '3.92', label: ['3', '55'] },
    { value: '4', label: ['4', '0'] },
    { value: '4.08', label: ['4', '5'] },
    { value: '4.17', label: ['4', '10'] },
    { value: '4.25', label: ['4', '15'] },
    { value: '4.33', label: ['4', '20'] },
    { value: '4.42', label: ['4', '25'] },
    { value: '4.5', label: ['4', '30'] },
    { value: '4.58', label: ['4', '35'] },
    { value: '4.67', label: ['4', '40'] },
    { value: '4.75', label: ['4', '45'] },
    { value: '4.83', label: ['4', '50'] },
    { value: '4.92', label: ['4', '55'] },
    { value: '5', label: ['5', '0'] },
    { value: '5.08', label: ['5', '5'] },
    { value: '5.17', label: ['5', '10'] },
    { value: '5.25', label: ['5', '15'] },
    { value: '5.33', label: ['5', '20'] },
    { value: '5.42', label: ['5', '25'] },
    { value: '5.5', label: ['5', '30'] },
    { value: '5.58', label: ['5', '35'] },
    { value: '5.67', label: ['5', '40'] },
    { value: '5.75', label: ['5', '45'] },
    { value: '5.83', label: ['5', '50'] },
    { value: '5.92', label: ['5', '55'] },
    { value: '6', label: ['6', '0'] },
    { value: '6.08', label: ['6', '5'] },
    { value: '6.17', label: ['6', '10'] },
    { value: '6.25', label: ['6', '15'] },
    { value: '6.33', label: ['6', '20'] },
    { value: '6.42', label: ['6', '25'] },
    { value: '6.5', label: ['6', '30'] },
    { value: '6.58', label: ['6', '35'] },
    { value: '6.67', label: ['6', '40'] },
    { value: '6.75', label: ['6', '45'] },
    { value: '6.83', label: ['6', '50'] },
    { value: '6.92', label: ['6', '55'] },
    { value: '7', label: ['7', '0'] },
  ],

  CALCULATION_TIME_OUTPUT_ARRAY: [
    { value: '0', label: '0時00分' },
    { value: '0.08', label: '0時05分' },
    { value: '0.17', label: '0時10分' },
    { value: '0.25', label: '0時15分' },
    { value: '0.33', label: '0時20分' },
    { value: '0.42', label: '0時25分' },
    { value: '0.5', label: '0時30分' },
    { value: '0.58', label: '0時35分' },
    { value: '0.67', label: '0時40分' },
    { value: '0.75', label: '0時45分' },
    { value: '0.83', label: '0時50分' },
    { value: '0.92', label: '0時55分' },
    { value: '1', label: '1時00分' },
    { value: '1.08', label: '1時05分' },
    { value: '1.17', label: '1時10分' },
    { value: '1.25', label: '1時15分' },
    { value: '1.33', label: '1時20分' },
    { value: '1.42', label: '1時25分' },
    { value: '1.5', label: '1時30分' },
    { value: '1.58', label: '1時35分' },
    { value: '1.67', label: '1時40分' },
    { value: '1.75', label: '1時45分' },
    { value: '1.83', label: '1時50分' },
    { value: '1.92', label: '1時55分' },
    { value: '2', label: '2時00分' },
    { value: '2.08', label: '2時05分' },
    { value: '2.17', label: '2時10分' },
    { value: '2.25', label: '2時15分' },
    { value: '2.33', label: '2時20分' },
    { value: '2.42', label: '2時25分' },
    { value: '2.5', label: '2時30分' },
    { value: '2.58', label: '2時35分' },
    { value: '2.67', label: '2時40分' },
    { value: '2.75', label: '2時45分' },
    { value: '2.83', label: '2時50分' },
    { value: '2.92', label: '2時55分' },
    { value: '3', label: '3時00分' },
    { value: '3.08', label: '3時05分' },
    { value: '3.17', label: '3時10分' },
    { value: '3.25', label: '3時15分' },
    { value: '3.33', label: '3時20分' },
    { value: '3.42', label: '3時25分' },
    { value: '3.5', label: '3時30分' },
    { value: '3.58', label: '3時35分' },
    { value: '3.67', label: '3時40分' },
    { value: '3.75', label: '3時45分' },
    { value: '3.83', label: '3時50分' },
    { value: '3.92', label: '3時55分' },
    { value: '4', label: '4時00分' },
    { value: '4.08', label: '4時05分' },
    { value: '4.17', label: '4時10分' },
    { value: '4.25', label: '4時15分' },
    { value: '4.33', label: '4時20分' },
    { value: '4.42', label: '4時25分' },
    { value: '4.5', label: '4時30分' },
    { value: '4.58', label: '4時35分' },
    { value: '4.67', label: '4時40分' },
    { value: '4.75', label: '4時45分' },
    { value: '4.83', label: '4時50分' },
    { value: '4.92', label: '4時55分' },
    { value: '5', label: '5時00分' },
    { value: '5.08', label: '5時05分' },
    { value: '5.17', label: '5時10分' },
    { value: '5.25', label: '5時15分' },
    { value: '5.33', label: '5時20分' },
    { value: '5.42', label: '5時25分' },
    { value: '5.5', label: '5時30分' },
    { value: '5.58', label: '5時35分' },
    { value: '5.67', label: '5時40分' },
    { value: '5.75', label: '5時45分' },
    { value: '5.83', label: '5時50分' },
    { value: '5.92', label: '5時55分' },
    { value: '6', label: '6時00分' },
    { value: '6.08', label: '6時05分' },
    { value: '6.17', label: '6時10分' },
    { value: '6.25', label: '6時15分' },
    { value: '6.33', label: '6時20分' },
    { value: '6.42', label: '6時25分' },
    { value: '6.5', label: '6時30分' },
    { value: '6.58', label: '6時35分' },
    { value: '6.67', label: '6時40分' },
    { value: '6.75', label: '6時45分' },
    { value: '6.83', label: '6時50分' },
    { value: '6.92', label: '6時55分' },
    { value: '7', label: '7時00分' },
  ],

  TAX_ARRAY: [
    {
      label: '非課税',
      value: '1',
    },
    {
      label: '10%',
      value: '1.1',
    },
    {
      label: '8%（軽減税率）',
      value: '1.08',
    },
  ],
  SCHOOL_OPEN_OR_CLOSED_ARRAY: [
    {
      label: '開校日にする',
      value: '0',
    },
    {
      label: '休校日にする',
      value: '1',
    },
  ],
  LINE_FILTER_ARRAY: [
    {
      label: 'すべて',
      value: '0',
      icon: 'comment',
    },
    {
      label: '未読',
      value: '1',
      icon: 'envelope',
    },
    {
      label: '要対応',
      value: '2',
      icon: 'comments',
    },
    {
      label: '対応済み',
      value: '3',
      icon: 'check',
    },
  ],
  LINE_STATUS_ARRAY: [
    {
      label: '要対応',
      value: '1',
      icon: 'comments',
    },
    {
      label: '対応済み',
      value: '2',
      icon: 'check',
    },
  ],
  LINE_SEGMENT_DELIVERY_DESTINATION_ARRAY: [
    {
      label: 'すべての友達',
      value: '0',
    },
    {
      label: '絞り込み',
      value: '1',
    },
  ],
  CHILD_KASAN_SUPPORT_1_DETAILS_ARRAY: [
    {
      label: '選択してください',
      value: '0',
    },
    {
      label: 'ケアニーズの高い障害児に支援を行った場合',
      value: '1',
    },
    {
      label: '基礎研修修了者支援をおこなった場合',
      value: '2',
    },
    {
      label: '著しく重度の障害児に支援を行った場合',
      value: '3',
    },
  ],
  TUTORING_FIVE_AREAS_ARRAY: [
    '健康・生活',
    '運動・感覚',
    '認知・行動',
    '言語・コミュニケーション',
    '人間関係・社会性',
  ],
  TUTORING_STATUS_ARRAY: [
    '作成中',
    '計画同意待ち',
    '計画同意済み',
    '評価同意待ち',
    '評価同意済み',
  ],
  BANK_TYPE: [
    {
      value: 0,
      label: '選択してください',
    },
    {
      value: 1,
      label: '基本パターン',
    },
    {
      value: 2,
      label: 'ゆうちょ',
    },
    {
      value: 3,
      label: 'みずほファクター',
    },
    {
      value: 4,
      label: 'JACCS',
    },
  ],
  BASIC_TRANSACTION_DEPOSIT_TYPE: [
    {
      value: 1,
      label: '普通',
    },
    {
      value: 2,
      label: '当座',
    },
    {
      value: 9,
      label: 'その他',
    },
  ],
  YUCHO_TRANSACTION_DEPOSIT_TYPE: [
    {
      value: 1,
      label: '総合口座',
    },
    {
      value: 2,
      label: '振替口座',
    },
  ],
  WITHDRAWAL_PERIOD: [
    {
      value: 0,
      label: '当月',
    },
    {
      value: 1,
      label: '翌月',
    },
  ],
  WITHDRAWAL_DEPOSIT_TYPE: [
    {
      value: 1,
      label: '普通',
    },
    {
      value: 2,
      label: '当座',
    },
  ],
  KIJYUN_GAITO_ARRAY: [
    {
      text: '基準該当1',
      value: '1',
    },
    {
      text: '基準該当2',
      value: '2',
    },
  ],
  PICK_POINT_ARRAY: [
    {
      text: '自宅',
      value: '1',
    },
    {
      text: '学校',
      value: '2',
    },
    {
      text: 'その他',
      value: '3',
    },
  ],
  SEND_POINT_ARRAY: [
    {
      text: '自宅',
      value: '1',
    },
    {
      text: 'その他',
      value: '3',
    },
  ],
  OFFICE_KYOSEIGATA_SERVICE_ARRAY: [
    {
      text: '非該当',
      value: '0',
    },
    {
      text: '該当',
      value: '1',
    },
  ],
  OFFICE_KYOSEIGATA_SERVICE_DETAIL_ARRAY: [
    {
      text: '非該当',
      value: '0',
    },
    {
      text: '児発管かつ保育士又は児童指導員の配置（加算1）',
      value: '1',
    },
    {
      text: '児発管の配置（加算2）',
      value: '2',
    },
    {
      text: '保育士又は児童指導員の配置（加算3）',
      value: '3',
    },
  ],
  ACHIVEMENTS_REVISION_2024_KASAN_DEFAULT_ARRAY: [
    {
      key: 'medicalCooperation',
      value: '0',
    },
    {
      key: 'medicalCooperationStartHour',
      value: '00',
    },
    {
      key: 'medicalCooperationStartMinute',
      value: '00',
    },
    {
      key: 'medicalCooperationEndHour',
      value: '00',
    },
    {
      key: 'medicalCooperationEndMinute',
      value: '00',
    },
    {
      key: 'organizationAddition',
      value: 0,
    },
    {
      key: 'organizationAdditionStartHour',
      value: '00',
    },
    {
      key: 'organizationAdditionStartMinute',
      value: '00',
    },
    {
      key: 'organizationAdditionEndHour',
      value: '00',
    },
    {
      key: 'organizationAdditionEndMinute',
      value: '00',
    },
    {
      key: 'organizationAddition2',
      value: 0,
    },
    {
      key: 'organizationAddition2StartHour',
      value: '00',
    },
    {
      key: 'organizationAddition2StartMinute',
      value: '00',
    },
    {
      key: 'organizationAddition2EndHour',
      value: '00',
    },
    {
      key: 'organizationAddition2EndMinute',
      value: '00',
    },
    {
      key: 'organizationAddition3',
      value: 0,
    },
    {
      key: 'organizationAddition3StartHour',
      value: '00',
    },
    {
      key: 'organizationAddition3StartMinute',
      value: '00',
    },
    {
      key: 'organizationAddition3EndHour',
      value: '00',
    },
    {
      key: 'organizationAddition3EndMinute',
      value: '00',
    },
    {
      key: 'organizationAddition4',
      value: 0,
    },
    {
      key: 'organizationAddition4StartHour',
      value: '00',
    },
    {
      key: 'organizationAddition4StartMinute',
      value: '00',
    },
    {
      key: 'organizationAddition4EndHour',
      value: '00',
    },
    {
      key: 'organizationAddition4EndMinute',
      value: '00',
    },
    {
      key: 'calculationTime',
      value: '0',
    },
    {
      key: 'kasanStrength',
      value: '0',
    },
    {
      key: 'kasanExtended',
      value: '0',
    },
    {
      key: 'kasanTsushoJiritsu',
      value: '0',
    },
    {
      key: 'kasanNyuyoku',
      value: '0',
    },
    {
      key: 'kasanKinoShogaiji',
      value: '0',
    },
    {
      key: 'kasanKazokuShien',
      value: '0',
    },
    {
      key: 'kasanKazokuShienStartHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShienStartHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShienStartMinute',
      value: '00',
    },
    {
      key: 'kasanKazokuShienEndHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShienEndMinute',
      value: '00',
    },
    {
      key: 'kasanKazokuShienPlace',
      value: '0',
    },
    {
      key: 'kasanKazokuShien1',
      value: '0',
    },
    {
      key: 'kasanKazokuShien1StartHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShien1StartHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShien1StartMinute',
      value: '00',
    },
    {
      key: 'kasanKazokuShien1EndHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShien1EndMinute',
      value: '00',
    },
    {
      key: 'kasanKazokuShien1Place',
      value: '0',
    },
    {
      key: 'kasanKazokuShien2',
      value: '0',
    },
    {
      key: 'kasanKazokuShien2StartHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShien2StartHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShien2StartMinute',
      value: '00',
    },
    {
      key: 'kasanKazokuShien2EndHour',
      value: '00',
    },
    {
      key: 'kasanKazokuShien2EndMinute',
      value: '00',
    },
    {
      key: 'kasanKazokuShien2Place',
      value: '0',
    },
    {
      key: 'kasanKosodateSupport',
      value: '0',
    },
    {
      key: 'kasanSenmontekiJisshi',
      value: '0',
    },
    {
      key: 'kasanShuchu',
      value: '0',
    },
    {
      key: 'kasanJigyoshokan',
      value: '0',
    },
    {
      key: 'kasanJiritsuSupport',
      value: '0',
    },
    {
      key: 'kasanIkoShien',
      value: '0',
    },
    {
      key: 'kasanMealOffer',
      value: '0',
    },
  ],
  ACHIVEMENTS_KASAN_DEFAULT_ARRAY: [
    {
      key: 'homeAddition',
      value: '0',
    },
    {
      key: 'homeAdditionStartHour',
      value: '00',
    },
    {
      key: 'homeAdditionStartMinute',
      value: '00',
    },
    {
      key: 'homeAdditionEndHour',
      value: '00',
    },
    {
      key: 'homeAdditionEndMinute',
      value: '00',
    },
    {
      key: 'medicalCooperation',
      value: '0',
    },
    {
      key: 'medicalCooperationStartHour',
      value: '00',
    },
    {
      key: 'medicalCooperationStartMinute',
      value: '00',
    },
    {
      key: 'medicalCooperationEndHour',
      value: '00',
    },
    {
      key: 'medicalCooperationEndMinute',
      value: '00',
    },
    {
      key: 'organizationAddition',
      value: 0,
    },
    {
      key: 'organizationAdditionStartHour',
      value: '00',
    },
    {
      key: 'organizationAdditionStartMinute',
      value: '00',
    },
    {
      key: 'organizationAdditionEndHour',
      value: '00',
    },
    {
      key: 'organizationAdditionEndMinute',
      value: '00',
    },
    {
      key: 'organizationAddition2',
      value: 0,
    },
    {
      key: 'organizationAddition2StartHour',
      value: '00',
    },
    {
      key: 'organizationAddition2StartMinute',
      value: '00',
    },
    {
      key: 'organizationAddition2EndHour',
      value: '00',
    },
    {
      key: 'organizationAddition2EndMinute',
      value: '00',
    },
    {
      key: 'consultationAddition',
      value: 0,
    },
    {
      key: 'consultationAdditionStartHour',
      value: '00',
    },
    {
      key: 'consultationAdditionStartMinute',
      value: '00',
    },
    {
      key: 'consultationAdditionEndHour',
      value: '00',
    },
    {
      key: 'consultationAdditionEndMinute',
      value: '00',
    },
    {
      key: 'consultationAddition2',
      value: 0,
    },
    {
      key: 'consultationAddition2StartHour',
      value: '00',
    },
    {
      key: 'consultationAddition2StartMinute',
      value: '00',
    },
    {
      key: 'consultationAddition2EndHour',
      value: '00',
    },
    {
      key: 'consultationAddition2EndMinute',
      value: '00',
    },
    {
      key: 'kasanStrength',
      value: '0',
    },
    {
      key: 'kasanExtended',
      value: '0',
    },
  ],
  ACHIVEMENTS_DEFAULT_ARRAY: [
    {
      key: 'remarks',
      value: '',
    },
    {
      key: 'pick',
      value: 0,
    },
    {
      key: 'send',
      value: 0,
    },
    {
      key: 'alternativeSupport',
      value: '0',
    },
  ],
  ACHIVEMENTS_REVISION_2024_VISIT_KASAN_DEFAULT_ARRAY: [
    {
      key: 'visitKasanFirst',
      value: '0',
    },
    {
      key: 'visitKasanSpecialArea',
      value: '0',
    },
    {
      key: 'visitKasanWelfare',
      value: '0',
    },
    {
      key: 'visitLeader',
      value: '',
    },
    {
      key: 'visitLeaderName',
      value: '',
    },
    {
      key: 'visitOrganizationAddition',
      value: 0,
    },
    {
      key: 'visitOrganizationAdditionStartHour',
      value: '00',
    },
    {
      key: 'visitOrganizationAdditionStartMinute',
      value: '00',
    },
    {
      key: 'visitOrganizationAdditionEndHour',
      value: '00',
    },
    {
      key: 'visitOrganizationAdditionEndMinute',
      value: '00',
    },
    {
      key: 'visitKasanHomonShien',
      value: '0',
    },
    {
      key: 'visitKasanCareNeeds',
      value: '0',
    },
    {
      key: 'visitKasanStrength',
      value: '0',
    },
    {
      key: 'visitKasanKazokuShien',
      value: '0',
    },
    {
      key: 'visitKasanKazokuShienStartHour',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShienStartMinute',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShienEndHour',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShienEndMinute',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShienPlace',
      value: '0',
    },
    {
      key: 'visitKasanKazokuShien1',
      value: '0',
    },
    {
      key: 'visitKasanKazokuShien1StartHour',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShien1StartMinute',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShien1EndHour',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShien1EndMinute',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShien1Place',
      value: '0',
    },
    {
      key: 'visitKasanKazokuShien2',
      value: '0',
    },
    {
      key: 'visitKasanKazokuShien2StartHour',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShien2StartMinute',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShien2EndHour',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShien2EndMinute',
      value: '00',
    },
    {
      key: 'visitKasanKazokuShien2Place',
      value: '0',
    },
    {
      key: 'visitKasanTashugyo',
      value: '0',
    },
    {
      key: 'visitRemarks',
      value: '',
    },
    {
      key: 'isVisitMultiple',
      value: '0',
    },
  ],
  ACHIVEMENTS_VISIT_KASAN_DEFAULT_ARRAY: [
    {
      key: 'visitKasanFirst',
      value: '0',
    },
    {
      key: 'visitKasanSpecialArea',
      value: '0',
    },
    {
      key: 'visitKasanWelfare',
      value: '0',
    },
    {
      key: 'visitLeader',
      value: '',
    },
    {
      key: 'visitLeaderName',
      value: '',
    },
    {
      key: 'visitRemarks',
      value: '',
    },
    {
      key: 'isVisitMultiple',
      value: '0',
    },
    {
      key: 'visitHomeAddition',
      value: '0',
    },
    {
      key: 'visitHomeAdditionStartHour',
      value: '00',
    },
    {
      key: 'visitHomeAdditionStartMinute',
      value: '00',
    },
    {
      key: 'visitHomeAdditionEndHour',
      value: '00',
    },
    {
      key: 'visitHomeAdditionEndMinute',
      value: '00',
    },
  ],
  APPLICABLE_OPTION_ARRAY: ['非該当', '該当'],
  PHYSICALDISABILITYNOTEBOOK_SELECT_OPTION_ARRAY: [
    '選択してください',
    '1級',
    '2級',
    '3級',
    '4級',
    '5級',
    '6級',
    '7級',
  ],
  TOKUREI_OPTION_ARRAY: ['特例の適用なし', '特例の適用あり'],
  NAV_BASIC_SURVEY_1_ANCHORS_ARRAY: [
    { text: '児童', id: '1-2', tab: 0 },
    { text: '住所', id: '1-3', tab: 0 },
    { text: '連絡先', id: '1-4', tab: 0 },
    { text: 'ご相談', id: '1-5', tab: 1 },
    { text: '通園・通学・就業先', id: '1-6', tab: 1 },
    { text: '関係機関との情報共有について', id: '1-7', tab: 1 },
    { text: '世帯形態', id: '1-8', tab: 2 },
    { text: '世帯状況', id: '1-9', tab: 2 },
    { text: '出生期', id: '1-10', tab: 3 },
    { text: '胎生期', id: '1-11', tab: 3 },
    { text: '乳幼児期', id: '1-12', tab: 3 },
    { text: '手帳', id: '1-13', tab: 4 },
    { text: '健康保険証', id: '1-14', tab: 4 },
    { text: '要介護度', id: '1-15', tab: 4 },
    { text: '障害支援区分', id: '1-16', tab: 4 },
    { text: '収入', id: '1-17', tab: 4 },
    { text: '既往・現病歴', id: '1-18', tab: 5 },
    { text: '支援の状況', id: '1-19', tab: 5 },
  ],
  NAV_BASIC_SURVEY_2_ANCHORS_ARRAY: [
    { text: '記入者情報', id: '2-1', tab: 0 },
    { text: '健診での指摘', id: '2-2', tab: 1 },
    { text: '生育の様子', id: '2-3', tab: 1 },
    { text: '学齢期', id: '2-4', tab: 2 },
    { text: '学齢期以降～現在の様子', id: '2-5', tab: 2 },
  ],
  NAV_BASIC_SURVEY_3_ANCHORS_ARRAY: [
    { text: '記入者情報', id: '3-1', tab: 0 },
    { text: '床上', id: '3-2', tab: 0 },
    { text: '移動', id: '3-3', tab: 1 },
    { text: '入浴', id: '3-4', tab: 1 },
    { text: '排泄', id: '3-5', tab: 2 },
    { text: '食事', id: '3-6', tab: 3 },
    { text: '清潔', id: '3-7', tab: 4 },
    { text: '着脱', id: '3-8', tab: 4 },
    { text: 'I-ADL', id: '3-9', tab: 4 },
    { text: '視力', id: '3-10', tab: 5 },
    { text: '聴力', id: '3-11', tab: 5 },
    { text: '意思の伝達', id: '3-12', tab: 5 },
    { text: 'コミュニケーション', id: '3-13', tab: 6 },
    { text: '生活', id: '3-14', tab: 6 },
    { text: 'コミュニケーション', id: '3-15', tab: 7 },
    { text: '日常生活', id: '3-16', tab: 7 },
    { text: '社会生活', id: '3-17', tab: 8 },
    { text: '要配慮行動', id: '3-18', tab: 8 },
    { text: '身の回りのこと', id: '3-19', tab: 9 },
    { text: '安全管理', id: '3-20', tab: 9 },
    { text: '健康管理', id: '3-21', tab: 10 },
    { text: '社会資源の活用', id: '3-22', tab: 10 },
    { text: '対人関係', id: '3-23', tab: 10 },
    { text: '社会的役割・時間の活用', id: '3-24', tab: 10 },
    { text: '対応', id: '3-25', tab: 11 },
    { text: '社会行動', id: '3-26', tab: 11 },
    { text: '生活上の問題', id: '3-27', tab: 12 },
    { text: '主治医の意見', id: '3-28', tab: 12 },
  ],
  NAV_BASIC_SURVEY_4_ANCHORS_ARRAY: [
    { text: '記入者情報', id: '4-1', tab: 0 },
    { text: '服薬状況', id: '4-2', tab: 0 },
    { text: '身体状況', id: '4-3', tab: 1 },
    { text: '口腔状態', id: '4-4', tab: 1 },
    { text: '睡眠', id: '4-5', tab: 2 },
    { text: '生活歴', id: '4-6', tab: 2 },
    { text: '嗜好', id: '4-7', tab: 2 },
    { text: '社会的活動等', id: '4-8', tab: 2 },
    { text: '1日の過ごし方\n家庭内での役割・日課', id: '4-9', tab: 2 },
  ],
}
